(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1496],{

/***/ 14418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useWindowDimensions = function useWindowDimensions() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    width: undefined,
    height: undefined
  }),
      windowDimensions = _useState[0],
      setWindowDimensions = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    function handleResize() {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }

    handleResize();
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  return windowDimensions;
};

/* harmony default export */ __webpack_exports__["Z"] = (useWindowDimensions);

/***/ }),

/***/ 57208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LeadForm": function() { return /* binding */ LeadForm; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(36864);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(79072);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(70754);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72145);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85014);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82580);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(28719);
/* harmony import */ var _form_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(11455);
/* harmony import */ var _form_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_form_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67555);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31955);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var selectStyles = {
  control: function control(styles) {
    return _objectSpread(_objectSpread({}, styles), {}, {
      backgroundColor: "white",
      fontSize: "14px",
      padding: "5px",
      border: "1px solid #ebe9f1 !important",
      boxShadow: "0 !important",
      "&:hover": {
        border: "1px solid #ebe9f1 !important"
      }
    });
  },
  option: function option(styles, _ref) {
    var isDisabled = _ref.isDisabled,
        isFocused = _ref.isFocused,
        isSelected = _ref.isSelected;
    var color = "#333";
    return _objectSpread(_objectSpread({}, styles), {}, {
      fontSize: "13px",
      // maxHeight: "150px",
      color: isSelected ? "#F47F20" : "#B5B5C3",
      backgroundColor: isSelected ? "#F5F6FC" : isFocused ? "#F5F6FC" : styles.backgroundColor,
      "&:hover": {
        backgroundColor: "#F5F6FC",
        color: "#F47F20"
      },
      cursor: isDisabled ? "not-allowed" : "pointer"
    });
  },
  menuPortal: function menuPortal(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      zIndex: 9999
    });
  },
  menu: function menu(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      zIndex: 9999,
      overflow: "auto" // maxHeight: "150px",

    });
  },
  placeholder: function placeholder(defaultStyles) {
    return _objectSpread(_objectSpread({}, defaultStyles), {}, {
      color: "#c2c2c2",
      fontSize: "13px"
    });
  }
};
var LeadForm = function LeadForm(_ref2) {
  var pageData = _ref2.pageData,
      _ref2$showTitle = _ref2.showTitle,
      showTitle = _ref2$showTitle === void 0 ? true : _ref2$showTitle,
      _ref2$showSubTitle = _ref2.showSubTitle,
      showSubTitle = _ref2$showSubTitle === void 0 ? true : _ref2$showSubTitle,
      buttonTitle = _ref2.buttonTitle,
      _ref2$btnSizeFull = _ref2.btnSizeFull,
      btnSizeFull = _ref2$btnSizeFull === void 0 ? true : _ref2$btnSizeFull,
      handleClose = _ref2.handleClose,
      pageSlug = _ref2.pageSlug,
      _ref2$columnSizeFull = _ref2.columnSizeFull,
      columnSizeFull = _ref2$columnSizeFull === void 0 ? false : _ref2$columnSizeFull,
      onlyFormData = _ref2.onlyFormData,
      formTitle = _ref2.formTitle,
      formSubTitle = _ref2.formSubTitle,
      _ref2$formType = _ref2.formType,
      formType = _ref2$formType === void 0 ? "lead" : _ref2$formType;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
  var formData = pageData !== null && pageData !== void 0 && pageData.formSchema ? pageData === null || pageData === void 0 ? void 0 : pageData.formSchema : onlyFormData;
  var init = {
    terms_and_condition: false
  };
  var geolocationData = js_cookie__WEBPACK_IMPORTED_MODULE_10__/* ["default"].get */ .Z.get("default_country");

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(init),
      initialState = _useState[0],
      setInitialState = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(""),
      countryName = _useState2[0],
      setCountryName = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(geolocationData),
      countryFrom = _useState3[0],
      setCountryFrom = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(""),
      stateName = _useState4[0],
      setStateName = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(""),
      stateLabel = _useState5[0],
      setStateLabel = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(""),
      cityLabel = _useState6[0],
      setCityLabel = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)([]),
      stateList = _useState7[0],
      setStateList = _useState7[1];

  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)([]),
      cityList = _useState8[0],
      setCityList = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false),
      loading = _useState9[0],
      setLoading = _useState9[1];

  var _useState10 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(),
      defaultCountryCode = _useState10[0],
      setDefaultCountryCode = _useState10[1];

  (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function () {
    setTimeout(function () {
      if (js_cookie__WEBPACK_IMPORTED_MODULE_10__/* ["default"].get */ .Z.get("default_country")) {
        setDefaultCountryCode(js_cookie__WEBPACK_IMPORTED_MODULE_10__/* ["default"].get */ .Z.get("default_country"));
      }
    }, 1500);
  }, [defaultCountryCode]);

  var isFormEnable = function isFormEnable(values) {
    var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (errors && Object.keys(errors).length == 0 && values !== null && values !== void 0 && values.terms_and_condition) {
      return false;
    } else {
      return true;
    }
  };

  var emailTypeCheck = formData === null || formData === void 0 ? void 0 : formData.findIndex(function (item, i) {
    return item.type == "email";
  });
  var endpoint;

  if (formType === "event") {
    endpoint = "public/lead-contact-form/events-leads";
  }

  if (formType === "lead") {
    endpoint = "public/lead-contact-form";
  }

  var handleRegister = /*#__PURE__*/function () {
    var _ref4 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_ref3, actions) {
      var values;
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              values = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, _ref3);
              setLoading(true);
              _context.next = 4;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post(endpoint, {
                properties: _objectSpread(_objectSpread({}, values), countryFrom && {
                  Country: countryFrom
                }),
                emailExists: emailTypeCheck,
                slug: pageSlug ? pageSlug : router === null || router === void 0 ? void 0 : router.query.lead_page
              }).then(function (resp) {
                if (resp.error) {
                  (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .swalError */ .Kj)("Something went wrong");
                  setLoading(false);
                }

                if (!resp.error) {
                  //set localstorage
                  _unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .EncryptionStorage.setItem */ .GD.setItem("leadFormSubmitted", true);
                  (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .swalMessage */ .aS)("Welcome!", "You have successfully registered");
                  actions.resetForm();
                  setLoading(false);

                  if (handleClose) {
                    handleClose();
                  }
                }
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleRegister(_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }(); // const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;


  var phoneRegExp = /^\+?[0-9]{1,3}(\s|-)?\(?[0-9]{1,}\)?(\s|-)?[0-9\-\.]{2,}$/;

  var validationSchema = function validationSchema(values) {
    var errors = {};
    formData.forEach(function (item, i) {
      if (item.isRequired == 1) {
        if (!values[item.label]) {
          errors[item.label] = "Required Field";
        }
      }

      if (item.type == "number") {
        if (!phoneRegExp.test(values[item.label])) {
          errors[item.label] = "Invalid phone number!";
        }

        if (values[item.label] && values[item.label].length <= 9) {
          errors[item.label] = "Minimum length must be at least 9 characters";
        }

        if (values[item.label] && values[item.label].length >= 16) {
          errors[item.label] = "Maximum length must be less than 16 characters";
        }
      }

      if (item.type == "email") {
        if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(values[item.label])) {
          errors[item.label] = "Invalid email address!";
        }
      }
    });

    if (!values.terms_and_condition) {
      errors.terms_and_condition = "Required Field";
    }

    return errors;
  };

  var fetchState = /*#__PURE__*/function () {
    var _ref5 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
      var res;
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("public/lead-contact-form/".concat(countryName));

            case 2:
              res = _context2.sent;

              if (res && !res.error) {
                setStateList(res.data);
              }

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchState() {
      return _ref5.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function () {
    if (countryName) {
      fetchState();
    }
  }, [countryName]);

  var fetchCity = /*#__PURE__*/function () {
    var _ref6 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3() {
      var res;
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("public/lead-contact-form/state-info/".concat(countryName, "/").concat(stateName));

            case 2:
              res = _context3.sent;

              if (res && !res.error) {
                setCityList(res.data || []);
              }

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function fetchCity() {
      return _ref6.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function () {
    if (stateName) {
      fetchCity();
    }
  }, [stateName]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
      children: [formTitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
        className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().form_title_wrapper),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("h2", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
            children: formTitle ? (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .htmlParse */ .QA)(formTitle) : ""
          })
        }), formSubTitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("p", {
          children: formSubTitle
        })]
      }), (pageData === null || pageData === void 0 ? void 0 : pageData.formTitle) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
        className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().form_title_wrapper),
        children: [showTitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("h2", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
            children: pageData !== null && pageData !== void 0 && pageData.formTitle ? (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .htmlParse */ .QA)(pageData === null || pageData === void 0 ? void 0 : pageData.formTitle) : ""
          })
        }), showSubTitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("p", {
          children: pageData === null || pageData === void 0 ? void 0 : pageData.formDescription
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(formik__WEBPACK_IMPORTED_MODULE_4__/* .Formik */ .J9, {
      initialValues: initialState,
      enableReinitialize: true,
      validate: validationSchema,
      onSubmit: function onSubmit(values, actions) {
        handleRegister(values, actions);
      },
      children: function children(_ref7) {
        var handleSubmit = _ref7.handleSubmit,
            values = _ref7.values,
            setFieldValue = _ref7.setFieldValue,
            errors = _ref7.errors,
            touched = _ref7.touched;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_4__/* .Form */ .l0, {
          className: "form",
          autoComplete: "off",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
            container: true,
            columnSpacing: {
              xs: 2,
              sm: 2,
              md: 4
            },
            children: formData === null || formData === void 0 ? void 0 : formData.map(function (item, i) {
              if (item.type == "textarea") {
                var _values$item$label;

                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
                  item: true,
                  xs: 12,
                  sm: columnSizeFull ? 12 : item !== null && item !== void 0 && item.columnSize ? parseInt(item === null || item === void 0 ? void 0 : item.columnSize) : 12,
                  md: columnSizeFull ? 12 : item !== null && item !== void 0 && item.columnSize ? parseInt(item === null || item === void 0 ? void 0 : item.columnSize) : 12,
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                    className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().form_group),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("label", {
                      htmlFor: item === null || item === void 0 ? void 0 : item.name,
                      children: [item === null || item === void 0 ? void 0 : item.label, " ", (item === null || item === void 0 ? void 0 : item.isRequired) == 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                        className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().asterisk),
                        children: "*"
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("textarea", {
                      id: item === null || item === void 0 ? void 0 : item.name,
                      name: item === null || item === void 0 ? void 0 : item.label,
                      placeholder: item === null || item === void 0 ? void 0 : item.placeholder,
                      value: (_values$item$label = values[item === null || item === void 0 ? void 0 : item.label]) !== null && _values$item$label !== void 0 ? _values$item$label : "",
                      onChange: function onChange(e) {
                        setFieldValue(item === null || item === void 0 ? void 0 : item.label, e.target.value);
                        touched[item === null || item === void 0 ? void 0 : item.label] = true;
                      }
                    })]
                  }), errors[item.label] && touched[item.label] ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                    className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().error_msg),
                    children: errors[item.label]
                  }) : null]
                }, item.name);
              } else if (item.type == "select" || item.type == "country") {
                var _item$options, _item$options2;

                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
                  item: true,
                  xs: 12,
                  sm: columnSizeFull ? 12 : item !== null && item !== void 0 && item.columnSize ? parseInt(item === null || item === void 0 ? void 0 : item.columnSize) : 12,
                  md: columnSizeFull ? 12 : item !== null && item !== void 0 && item.columnSize ? parseInt(item === null || item === void 0 ? void 0 : item.columnSize) : 12,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                    className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().form_group),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("label", {
                      htmlFor: item === null || item === void 0 ? void 0 : item.name,
                      children: [item === null || item === void 0 ? void 0 : item.label, " ", (item === null || item === void 0 ? void 0 : item.isRequired) == 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                        className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().asterisk),
                        children: " *"
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP, {
                      id: item === null || item === void 0 ? void 0 : item.label,
                      instanceId: item === null || item === void 0 ? void 0 : item.label,
                      name: item === null || item === void 0 ? void 0 : item.label,
                      styles: selectStyles,
                      placeholder: (item === null || item === void 0 ? void 0 : item.placeholder) || "Please Select",
                      options: (_item$options = item === null || item === void 0 ? void 0 : item.options) !== null && _item$options !== void 0 ? _item$options : [],
                      onChange: function onChange(option) {
                        if ((item === null || item === void 0 ? void 0 : item.type) == "country") {
                          setCountryName(option.value);
                          setFieldValue(stateLabel, "");
                          setFieldValue(cityLabel, "");
                          fetchState();
                          setCityList([]);
                        }

                        setFieldValue(item === null || item === void 0 ? void 0 : item.label, option.label);
                        touched[item === null || item === void 0 ? void 0 : item.label] = true;
                      },
                      value: item !== null && item !== void 0 && item.options ? item === null || item === void 0 ? void 0 : (_item$options2 = item.options) === null || _item$options2 === void 0 ? void 0 : _item$options2.filter(function (filtered) {
                        return filtered.value === values[item.label];
                      }) : {}
                    }), errors[item.label] && touched[item.label] ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                      className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().error_msg),
                      children: errors[item.label]
                    }) : null]
                  })
                }, item.name);
              } else if (item.type == "state") {
                setStateLabel(item === null || item === void 0 ? void 0 : item.label);
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
                  item: true,
                  xs: 12,
                  sm: columnSizeFull ? 12 : item !== null && item !== void 0 && item.columnSize ? parseInt(item === null || item === void 0 ? void 0 : item.columnSize) : 12,
                  md: columnSizeFull ? 12 : item !== null && item !== void 0 && item.columnSize ? parseInt(item === null || item === void 0 ? void 0 : item.columnSize) : 12,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                    className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().form_group),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("label", {
                      htmlFor: item === null || item === void 0 ? void 0 : item.name,
                      children: [item === null || item === void 0 ? void 0 : item.label, " ", (item === null || item === void 0 ? void 0 : item.isRequired) == 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                        className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().asterisk),
                        children: " *"
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP, {
                      name: item === null || item === void 0 ? void 0 : item.label,
                      instanceId: item === null || item === void 0 ? void 0 : item.label,
                      id: item === null || item === void 0 ? void 0 : item.label,
                      styles: selectStyles,
                      placeholder: (item === null || item === void 0 ? void 0 : item.placeholder) || "Please Select",
                      options: stateList !== null && stateList !== void 0 ? stateList : [],
                      onChange: function onChange(stat) {
                        setFieldValue(item === null || item === void 0 ? void 0 : item.label, stat.label);
                        touched[item === null || item === void 0 ? void 0 : item.label] = true;
                        setStateName(stat.label);
                        fetchCity();
                      },
                      value: stateList ? stateList === null || stateList === void 0 ? void 0 : stateList.filter(function (filtered) {
                        return filtered.value === values[item === null || item === void 0 ? void 0 : item.label];
                      }) : {}
                    }), errors[item.label] && touched[item.label] ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                      className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().error_msg),
                      children: errors[item.label]
                    }) : null]
                  })
                }, item.name);
              } else if (item.type == "city") {
                setCityLabel(item === null || item === void 0 ? void 0 : item.label);
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
                  item: true,
                  xs: 12,
                  sm: columnSizeFull ? 12 : item !== null && item !== void 0 && item.columnSize ? parseInt(item === null || item === void 0 ? void 0 : item.columnSize) : 12,
                  md: columnSizeFull ? 12 : item !== null && item !== void 0 && item.columnSize ? parseInt(item === null || item === void 0 ? void 0 : item.columnSize) : 12,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                    className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().form_group),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("label", {
                      htmlFor: item === null || item === void 0 ? void 0 : item.name,
                      children: [item === null || item === void 0 ? void 0 : item.label, " ", (item === null || item === void 0 ? void 0 : item.isRequired) == 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                        className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().asterisk),
                        children: " *"
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP, {
                      name: item === null || item === void 0 ? void 0 : item.label,
                      instanceId: item === null || item === void 0 ? void 0 : item.label,
                      id: item === null || item === void 0 ? void 0 : item.label,
                      styles: selectStyles,
                      placeholder: (item === null || item === void 0 ? void 0 : item.placeholder) || "Please Select",
                      options: cityList !== null && cityList !== void 0 ? cityList : [],
                      onChange: function onChange(cty) {
                        setFieldValue(item === null || item === void 0 ? void 0 : item.label, cty.value);
                        touched[item === null || item === void 0 ? void 0 : item.label] = true;
                      },
                      value: cityList ? cityList === null || cityList === void 0 ? void 0 : cityList.filter(function (filtered) {
                        return filtered.value === values[item.label];
                      }) : {}
                    }), errors[item.label] && touched[item.label] ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                      className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().error_msg),
                      children: errors[item.label]
                    }) : null]
                  })
                }, item.name);
              } else if (item.type == "radio") {
                var _item$options3;

                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
                  item: true,
                  xs: 12,
                  sm: columnSizeFull ? 12 : item !== null && item !== void 0 && item.columnSize ? parseInt(item === null || item === void 0 ? void 0 : item.columnSize) : 12,
                  md: columnSizeFull ? 12 : item !== null && item !== void 0 && item.columnSize ? parseInt(item === null || item === void 0 ? void 0 : item.columnSize) : 12,
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                    className: "".concat((_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().form_group)),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("label", {
                      style: {
                        display: "block",
                        marginBottom: "8px"
                      },
                      children: [item === null || item === void 0 ? void 0 : item.label, " ", (item === null || item === void 0 ? void 0 : item.isRequired) == 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                        className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().asterisk),
                        children: " *"
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                      className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().dynamic_form_checkbox_wrapper),
                      children: item === null || item === void 0 ? void 0 : (_item$options3 = item.options) === null || _item$options3 === void 0 ? void 0 : _item$options3.map(function (option, i) {
                        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("label", {
                          className: "radio_container",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                            children: option === null || option === void 0 ? void 0 : option.label
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(formik__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                            type: "radio",
                            name: item === null || item === void 0 ? void 0 : item.label,
                            value: option === null || option === void 0 ? void 0 : option.label
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                            className: "radio_checkmark"
                          })]
                        }, "radio".concat(i));
                      })
                    })]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                    className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().error_msg),
                    children: errors[item.label]
                  })]
                }, item.name);
              } else if (item.type == "checkbox") {
                var _item$options4;

                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
                  item: true,
                  xs: 12,
                  sm: columnSizeFull ? 12 : item !== null && item !== void 0 && item.columnSize ? parseInt(item === null || item === void 0 ? void 0 : item.columnSize) : 12,
                  md: columnSizeFull ? 12 : item !== null && item !== void 0 && item.columnSize ? parseInt(item === null || item === void 0 ? void 0 : item.columnSize) : 12,
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                    className: "".concat((_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().form_group)),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("label", {
                      style: {
                        display: "block",
                        marginBottom: "8px"
                      },
                      children: [item === null || item === void 0 ? void 0 : item.label, " ", (item === null || item === void 0 ? void 0 : item.isRequired) == 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                        className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().asterisk),
                        children: " *"
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                      className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().dynamic_form_checkbox_wrapper),
                      children: item === null || item === void 0 ? void 0 : (_item$options4 = item.options) === null || _item$options4 === void 0 ? void 0 : _item$options4.map(function (option, i) {
                        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("label", {
                          className: "checkbox_container",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                            children: option === null || option === void 0 ? void 0 : option.label
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(formik__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                            type: "checkbox",
                            name: item === null || item === void 0 ? void 0 : item.label,
                            value: option === null || option === void 0 ? void 0 : option.label
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                            className: "checkbox_checkmark"
                          })]
                        }, "checkbox".concat(i));
                      })
                    })]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                    className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().error_msg),
                    children: errors[item === null || item === void 0 ? void 0 : item.label]
                  })]
                }, item.name);
              } else if (item.type == "number") {
                var _values$item$label2;

                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
                  item: true,
                  xs: 12,
                  sm: columnSizeFull ? 12 : item !== null && item !== void 0 && item.columnSize ? parseInt(item === null || item === void 0 ? void 0 : item.columnSize) : 12,
                  md: columnSizeFull ? 12 : item !== null && item !== void 0 && item.columnSize ? parseInt(item === null || item === void 0 ? void 0 : item.columnSize) : 12,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                    className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().form_group),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("label", {
                      htmlFor: item === null || item === void 0 ? void 0 : item.name,
                      children: [item === null || item === void 0 ? void 0 : item.label, " ", (item === null || item === void 0 ? void 0 : item.isRequired) == 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                        className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().asterisk),
                        children: " *"
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((react_phone_input_2__WEBPACK_IMPORTED_MODULE_8___default()), {
                      autoFormat: false,
                      country: defaultCountryCode !== null && defaultCountryCode !== void 0 ? defaultCountryCode : "",
                      value: (_values$item$label2 = values[item === null || item === void 0 ? void 0 : item.label]) !== null && _values$item$label2 !== void 0 ? _values$item$label2 : "",
                      onChange: function onChange(_value, country, _event, formattedValue) {
                        setCountryFrom(country === null || country === void 0 ? void 0 : country.name);
                        setFieldValue(item === null || item === void 0 ? void 0 : item.label, formattedValue);
                        touched[item === null || item === void 0 ? void 0 : item.label] = true;
                      },
                      name: item === null || item === void 0 ? void 0 : item.label
                    }), errors[item.label] && touched[item.label] ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                      className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().error_msg),
                      children: errors[item.label]
                    }) : null]
                  })
                }, item.name);
              } else {
                var _values$item$label3;

                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
                  item: true,
                  xs: 12,
                  sm: columnSizeFull ? 12 : item !== null && item !== void 0 && item.columnSize ? parseInt(item === null || item === void 0 ? void 0 : item.columnSize) : 12,
                  md: columnSizeFull ? 12 : item !== null && item !== void 0 && item.columnSize ? parseInt(item === null || item === void 0 ? void 0 : item.columnSize) : 12,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                    className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().form_group),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("label", {
                      htmlFor: item === null || item === void 0 ? void 0 : item.name,
                      children: [item === null || item === void 0 ? void 0 : item.label, " ", (item === null || item === void 0 ? void 0 : item.isRequired) == 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                        className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().asterisk),
                        children: " *"
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("input", {
                      id: item === null || item === void 0 ? void 0 : item.name,
                      name: item === null || item === void 0 ? void 0 : item.label,
                      placeholder: item === null || item === void 0 ? void 0 : item.placeholder,
                      type: item === null || item === void 0 ? void 0 : item.type,
                      value: (_values$item$label3 = values[item === null || item === void 0 ? void 0 : item.label]) !== null && _values$item$label3 !== void 0 ? _values$item$label3 : "",
                      onChange: function onChange(e) {
                        setFieldValue(item === null || item === void 0 ? void 0 : item.label, e.target.value);
                        touched[item === null || item === void 0 ? void 0 : item.label] = true;
                      }
                    }), errors[item.label] && touched[item.label] ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                      className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().error_msg),
                      children: errors[item.label]
                    }) : null]
                  })
                }, item.name);
              }
            })
          }), (pageData === null || pageData === void 0 ? void 0 : pageData.formNote) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("p", {
            className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().promise_text),
            children: pageData === null || pageData === void 0 ? void 0 : pageData.formNote
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
            className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().checkbox_container_wrapper),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
              className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().checkbox_with_error_wrapper),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().checkbox_wrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("label", {
                  className: "".concat((_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().checkbox_lebel), " checkbox_container"),
                  html: "terms",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(formik__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                    id: "terms",
                    type: "checkbox",
                    name: "terms_and_condition",
                    className: "checkbox disable-team team_values",
                    value: true,
                    checked: values.terms_and_condition && values.terms_and_condition === true ? true : false,
                    onChange: function onChange(event) {
                      setFieldValue("terms_and_condition", event.target.checked);
                      touched.terms_and_condition = true;
                    }
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                    className: "checkbox_checkmark",
                    style: {
                      marginLeft: "0px",
                      marginTop: "2px"
                    }
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                    children: "I agree to UniSearch"
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                  legacyBehavior: true,
                  href: "/terms-and-conditions",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("a", {
                    className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().term_link),
                    children: "Terms"
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                  children: "and"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                  legacyBehavior: true,
                  href: "/privacy-policy",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("a", {
                    className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().term_link),
                    children: "Privacy Policy."
                  })
                })]
              }), errors !== null && errors !== void 0 && errors.terms_and_condition && touched !== null && touched !== void 0 && touched.terms_and_condition ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                className: (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().error_msg),
                children: errors.terms_and_condition
              }) : null]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("button", {
            type: "submit",
            className: "".concat((_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().register_btn), " btn btn-secondary btn-bg ").concat(btnSizeFull ? "btn-full" : "", " ").concat(loading || isFormEnable(values, errors) ? (_form_module_scss__WEBPACK_IMPORTED_MODULE_14___default().disabled) : "enable", " "),
            onClick: handleSubmit,
            disabled: loading || isFormEnable(values, errors) ? true : false,
            children: [loading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
              size: "16px",
              color: "inherit"
            }), buttonTitle || "Register Now"]
          })]
        });
      }
    })]
  });
};
/* harmony default export */ __webpack_exports__["default"] = (LeadForm);

/***/ }),

/***/ 56205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pn": function() { return /* reexport */ components_form.LeadForm; },
  "Q$": function() { return /* reexport */ LeadSectionCounsellingFeatures; },
  "qc": function() { return /* reexport */ LeadSectionFeatures; },
  "mt": function() { return /* reexport */ LeadSectionForm; },
  "Vs": function() { return /* reexport */ LeadSectionHero; },
  "NA": function() { return /* reexport */ LeadSectionHeroForm; },
  "AV": function() { return /* reexport */ LeadSectionHighlights; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./_modules/lead/components/section_heroform/heroform.module.scss
var heroform_module = __webpack_require__(89628);
var heroform_module_default = /*#__PURE__*/__webpack_require__.n(heroform_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_modules/lead/components/section_heroform/index.jsx







var LeadSectionHeroForm = function LeadSectionHeroForm(_ref) {
  var pageData = _ref.pageData;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (heroform_module_default()).section_heroform,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (heroform_module_default()).heroform_bg_image_wrapper,
      children: [(pageData === null || pageData === void 0 ? void 0 : pageData.featureImageSrc) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (heroform_module_default()).overlay
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: (pageData === null || pageData === void 0 ? void 0 : pageData.featureImageSrc) || (0,helpers/* getAssets */.Vh)("assets/images/background_with_circle.png"),
        alt: pageData === null || pageData === void 0 ? void 0 : pageData.title
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "".concat((heroform_module_default()).heading_wrapper, " ").concat(pageData !== null && pageData !== void 0 && pageData.featureImageSrc ? "" : (heroform_module_default()).color_black),
        children: [(pageData === null || pageData === void 0 ? void 0 : pageData.pageTitle) && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: pageData !== null && pageData !== void 0 && pageData.pageTitle ? (0,helpers/* htmlParse */.QA)(pageData === null || pageData === void 0 ? void 0 : pageData.pageTitle) : ""
        }), (pageData === null || pageData === void 0 ? void 0 : pageData.dynamicDescription) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (heroform_module_default()).sub_title,
          children: pageData !== null && pageData !== void 0 && pageData.dynamicDescription ? (0,helpers/* htmlParse */.QA)(pageData === null || pageData === void 0 ? void 0 : pageData.dynamicDescription) : ""
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (heroform_module_default()).form_wrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_form.LeadForm, {
          pageData: pageData
        })
      })]
    })]
  });
};
/* harmony default export */ var section_heroform = ((/* unused pure expression or super */ null && (LeadSectionHeroForm)));
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
// EXTERNAL MODULE: ./_modules/lead/components/section_hero/hero.module.scss
var hero_module = __webpack_require__(78503);
var hero_module_default = /*#__PURE__*/__webpack_require__.n(hero_module);
;// CONCATENATED MODULE: ./_modules/lead/components/section_hero/index.jsx










var LeadSectionHero = function LeadSectionHero(_ref) {
  var _pageData$pageContent, _pageData$pageContent2, _pageData$pageContent3, _pageData$pageContent4, _pageData$pageContent5, _pageData$pageContent6, _pageData$pageContent7, _pageData$pageContent8, _pageData$pageContent9;

  var pageData = _ref.pageData;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "".concat((hero_module_default()).section_hero, " ").concat(pageData !== null && pageData !== void 0 && pageData.featureImageSrc ? "" : (hero_module_default()).full_width),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: {
          xs: 3,
          sm: 3,
          md: 6
        },
        alignItems: "center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          sm: 12,
          md: pageData !== null && pageData !== void 0 && pageData.featureImageSrc ? 6 : 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "".concat((hero_module_default()).heading_wrapper, " from_texteditor_wrapper"),
            children: [(pageData === null || pageData === void 0 ? void 0 : pageData.pageTitle) && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: pageData !== null && pageData !== void 0 && pageData.pageTitle ? (0,helpers/* htmlParse */.QA)(pageData === null || pageData === void 0 ? void 0 : pageData.pageTitle) : ""
            }), (pageData === null || pageData === void 0 ? void 0 : pageData.dynamicDescription) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "".concat((hero_module_default()).sub_text, " "),
              children: pageData !== null && pageData !== void 0 && pageData.dynamicDescription ? (0,helpers/* htmlParse */.QA)(pageData === null || pageData === void 0 ? void 0 : pageData.dynamicDescription) : ""
            }), (pageData === null || pageData === void 0 ? void 0 : pageData.template) == "webinar" && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: ((pageData === null || pageData === void 0 ? void 0 : (_pageData$pageContent = pageData.pageContent) === null || _pageData$pageContent === void 0 ? void 0 : _pageData$pageContent.eventDate) || (pageData === null || pageData === void 0 ? void 0 : (_pageData$pageContent2 = pageData.pageContent) === null || _pageData$pageContent2 === void 0 ? void 0 : _pageData$pageContent2.startTime) || (pageData === null || pageData === void 0 ? void 0 : (_pageData$pageContent3 = pageData.pageContent) === null || _pageData$pageContent3 === void 0 ? void 0 : _pageData$pageContent3.endTime)) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (hero_module_default()).time_wrapper,
                children: [(pageData === null || pageData === void 0 ? void 0 : (_pageData$pageContent4 = pageData.pageContent) === null || _pageData$pageContent4 === void 0 ? void 0 : _pageData$pageContent4.eventDate) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (hero_module_default()).time_card,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                    src: (0,helpers/* getAssets */.Vh)("assets/images/webinar/calendar.svg")
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (hero_module_default()).time_text,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (hero_module_default()).time_text_bold,
                      children: "Date"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (hero_module_default()).time_text_normal,
                      children: moment_default()(pageData === null || pageData === void 0 ? void 0 : (_pageData$pageContent5 = pageData.pageContent) === null || _pageData$pageContent5 === void 0 ? void 0 : _pageData$pageContent5.eventDate).format("Do MMMM, YYYY")
                    })]
                  })]
                }), (pageData === null || pageData === void 0 ? void 0 : (_pageData$pageContent6 = pageData.pageContent) === null || _pageData$pageContent6 === void 0 ? void 0 : _pageData$pageContent6.startTime) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (hero_module_default()).time_card,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                    src: (0,helpers/* getAssets */.Vh)("assets/images/webinar/stopwatch.svg")
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (hero_module_default()).time_text,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (hero_module_default()).time_text_bold,
                      children: "Time"
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: (hero_module_default()).time_text_normal,
                      children: [moment_default()(pageData === null || pageData === void 0 ? void 0 : (_pageData$pageContent7 = pageData.pageContent) === null || _pageData$pageContent7 === void 0 ? void 0 : _pageData$pageContent7.startTime).format("LT"), " ", (pageData === null || pageData === void 0 ? void 0 : (_pageData$pageContent8 = pageData.pageContent) === null || _pageData$pageContent8 === void 0 ? void 0 : _pageData$pageContent8.endTime) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: ["to", " ", moment_default()(pageData === null || pageData === void 0 ? void 0 : (_pageData$pageContent9 = pageData.pageContent) === null || _pageData$pageContent9 === void 0 ? void 0 : _pageData$pageContent9.endTime).format("LT")]
                      })]
                    })]
                  })]
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (hero_module_default()).btn_wrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "#form",
                className: "btn btn-secondary btn-bg",
                children: "Book Now"
              })
            })]
          })
        }), (pageData === null || pageData === void 0 ? void 0 : pageData.featureImageSrc) && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          sm: 12,
          md: 6,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (hero_module_default()).hero_image_wrapper,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: pageData === null || pageData === void 0 ? void 0 : pageData.featureImageSrc,
              alt: pageData === null || pageData === void 0 ? void 0 : pageData.title
            })
          })
        })]
      })
    })
  });
};
/* harmony default export */ var section_hero = ((/* unused pure expression or super */ null && (LeadSectionHero)));
// EXTERNAL MODULE: ./_modules/lead/components/section_counselling_features/counselling_features.module.scss
var counselling_features_module = __webpack_require__(3575);
var counselling_features_module_default = /*#__PURE__*/__webpack_require__.n(counselling_features_module);
;// CONCATENATED MODULE: ./_modules/lead/components/section_counselling_features/index.jsx






var LeadSectionCounsellingFeatures = function LeadSectionCounsellingFeatures(_ref) {
  var _pageData$pageContent, _pageData$pageContent2, _pageData$pageContent3, _pageData$pageContent4;

  var pageData = _ref.pageData;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: (pageData === null || pageData === void 0 ? void 0 : (_pageData$pageContent = pageData.pageContent) === null || _pageData$pageContent === void 0 ? void 0 : (_pageData$pageContent2 = _pageData$pageContent.featuresSection) === null || _pageData$pageContent2 === void 0 ? void 0 : _pageData$pageContent2.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
      children: pageData === null || pageData === void 0 ? void 0 : (_pageData$pageContent3 = pageData.pageContent) === null || _pageData$pageContent3 === void 0 ? void 0 : (_pageData$pageContent4 = _pageData$pageContent3.featuresSection) === null || _pageData$pageContent4 === void 0 ? void 0 : _pageData$pageContent4.map(function (secData, i) {
        var _secData$featuresCard, _secData$featuresCard2;

        return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (counselling_features_module_default()).heading_wrapper,
              children: [(secData === null || secData === void 0 ? void 0 : secData.featureTitle) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: (counselling_features_module_default()).title,
                children: secData === null || secData === void 0 ? void 0 : secData.featureTitle
              }), (secData === null || secData === void 0 ? void 0 : secData.featureSubtitle) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (counselling_features_module_default()).sub_text,
                children: secData === null || secData === void 0 ? void 0 : secData.featureSubtitle
              })]
            }), (secData === null || secData === void 0 ? void 0 : (_secData$featuresCard = secData.featuresCard) === null || _secData$featuresCard === void 0 ? void 0 : _secData$featuresCard.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (counselling_features_module_default()).steps_card_wrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                spacing: {
                  xs: 2,
                  sm: 2,
                  md: 3
                },
                justifyContent: "center",
                children: secData === null || secData === void 0 ? void 0 : (_secData$featuresCard2 = secData.featuresCard) === null || _secData$featuresCard2 === void 0 ? void 0 : _secData$featuresCard2.map(function (item, i) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    md: 4,
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: (counselling_features_module_default()).step_card,
                      children: [(item === null || item === void 0 ? void 0 : item.cardIconSrc) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: (counselling_features_module_default()).step_card_icon,
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                          src: item === null || item === void 0 ? void 0 : item.cardIconSrc,
                          alt: "Featured icon"
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: (counselling_features_module_default()).step_desc,
                        children: item === null || item === void 0 ? void 0 : item.cardDescription
                      })]
                    })
                  }, "featureCard".concat(i));
                })
              })
            })]
          })
        }, i);
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
  });
};
/* harmony default export */ var section_counselling_features = ((/* unused pure expression or super */ null && (LeadSectionCounsellingFeatures)));
// EXTERNAL MODULE: ./_modules/lead/components/section_features/features.module.scss
var features_module = __webpack_require__(77647);
var features_module_default = /*#__PURE__*/__webpack_require__.n(features_module);
;// CONCATENATED MODULE: ./_modules/lead/components/section_features/index.jsx







var LeadSectionFeatures = function LeadSectionFeatures(_ref) {
  var _pageData$pageContent, _pageData$pageContent2, _pageData$pageContent3, _pageData$pageContent4, _pageData$pageContent5, _pageData$pageContent6, _pageData$pageContent7, _pageData$pageContent8;

  var pageData = _ref.pageData;
  var full_col = "";

  if (!(pageData !== null && pageData !== void 0 && (_pageData$pageContent = pageData.pageContent) !== null && _pageData$pageContent !== void 0 && _pageData$pageContent.featureTitle) && !(pageData !== null && pageData !== void 0 && (_pageData$pageContent2 = pageData.pageContent) !== null && _pageData$pageContent2 !== void 0 && _pageData$pageContent2.featureSubtitle)) {
    full_col = "full_col";
  }

  var cardLength = pageData === null || pageData === void 0 ? void 0 : (_pageData$pageContent3 = pageData.pageContent) === null || _pageData$pageContent3 === void 0 ? void 0 : (_pageData$pageContent4 = _pageData$pageContent3.featuresSection) === null || _pageData$pageContent4 === void 0 ? void 0 : _pageData$pageContent4.length;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: (pageData === null || pageData === void 0 ? void 0 : (_pageData$pageContent5 = pageData.pageContent) === null || _pageData$pageContent5 === void 0 ? void 0 : (_pageData$pageContent6 = _pageData$pageContent5.featuresSection) === null || _pageData$pageContent6 === void 0 ? void 0 : _pageData$pageContent6.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
      children: pageData === null || pageData === void 0 ? void 0 : (_pageData$pageContent7 = pageData.pageContent) === null || _pageData$pageContent7 === void 0 ? void 0 : (_pageData$pageContent8 = _pageData$pageContent7.featuresSection) === null || _pageData$pageContent8 === void 0 ? void 0 : _pageData$pageContent8.map(function (secData, i) {
        var _secData$featuresCard, _secData$featuresCard2;

        return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "".concat((features_module_default()).description_wrapper),
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (features_module_default()).description_title_wrapper // style={{ order: i % 2 == 0 ? "1" : "2" }}
                ,
                children: [(secData === null || secData === void 0 ? void 0 : secData.featureSubtitle) && /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                  className: (features_module_default()).description_sub_title,
                  children: secData === null || secData === void 0 ? void 0 : secData.featureSubtitle
                }), (secData === null || secData === void 0 ? void 0 : secData.featureTitle) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                  className: (features_module_default()).description_title,
                  children: secData === null || secData === void 0 ? void 0 : secData.featureTitle
                })]
              }), (secData === null || secData === void 0 ? void 0 : (_secData$featuresCard = secData.featuresCard) === null || _secData$featuresCard === void 0 ? void 0 : _secData$featuresCard.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                spacing: 3,
                justifyContent: "center" // style={{ order: i % 2 == 0 ? "2" : "1" }}
                ,
                children: (_secData$featuresCard2 = secData.featuresCard) === null || _secData$featuresCard2 === void 0 ? void 0 : _secData$featuresCard2.map(function (item, i) {
                  var bgColor = (0,helpers/* hexToRGB */.$W)(item === null || item === void 0 ? void 0 : item.cardColor);
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 4,
                    md: 4,
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "".concat((features_module_default()).description_card),
                      style: {
                        color: "".concat(item === null || item === void 0 ? void 0 : item.cardColor),
                        backgroundColor: "rgba(".concat(bgColor, ", .05)")
                      },
                      children: [(item === null || item === void 0 ? void 0 : item.cardIconSrc) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: (features_module_default()).description_card_img_wrapper,
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                          src: item === null || item === void 0 ? void 0 : item.cardIconSrc,
                          alt: "featured icon",
                          style: {
                            maxWidth: "30px"
                          }
                        })
                      }), (item === null || item === void 0 ? void 0 : item.cardDescription) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: (features_module_default()).description_card_text,
                        children: item === null || item === void 0 ? void 0 : item.cardDescription
                      })]
                    })
                  }, "featureCard".concat(i));
                })
              })]
            })
          })
        }, i);
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
  });
};
/* harmony default export */ var section_features = ((/* unused pure expression or super */ null && (LeadSectionFeatures)));
// EXTERNAL MODULE: ./_modules/lead/components/section_highlights/highlights.module.scss
var highlights_module = __webpack_require__(7792);
var highlights_module_default = /*#__PURE__*/__webpack_require__.n(highlights_module);
;// CONCATENATED MODULE: ./_modules/lead/components/section_highlights/index.jsx







var LeadSectionHighlights = function LeadSectionHighlights(_ref) {
  var _pageData$pageContent, _pageData$pageContent2, _pageData$pageContent3, _pageData$pageContent4;

  var pageData = _ref.pageData;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: (pageData === null || pageData === void 0 ? void 0 : (_pageData$pageContent = pageData.pageContent) === null || _pageData$pageContent === void 0 ? void 0 : (_pageData$pageContent2 = _pageData$pageContent.featuresSection) === null || _pageData$pageContent2 === void 0 ? void 0 : _pageData$pageContent2.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
      children: pageData === null || pageData === void 0 ? void 0 : (_pageData$pageContent3 = pageData.pageContent) === null || _pageData$pageContent3 === void 0 ? void 0 : (_pageData$pageContent4 = _pageData$pageContent3.featuresSection) === null || _pageData$pageContent4 === void 0 ? void 0 : _pageData$pageContent4.map(function (secData, i) {
        var _secData$featuresCard, _secData$featuresCard2;

        return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
          className: (highlights_module_default()).section_onlinetest,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [(secData === null || secData === void 0 ? void 0 : secData.featureTitle) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: (highlights_module_default()).title,
              children: secData === null || secData === void 0 ? void 0 : secData.featureTitle
            }), (secData === null || secData === void 0 ? void 0 : (_secData$featuresCard = secData.featuresCard) === null || _secData$featuresCard === void 0 ? void 0 : _secData$featuresCard.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
              container: true,
              spacing: {
                xs: 3,
                sm: 3,
                md: 4
              },
              justifyContent: "center",
              children: (_secData$featuresCard2 = secData.featuresCard) === null || _secData$featuresCard2 === void 0 ? void 0 : _secData$featuresCard2.map(function (item, i) {
                var _secData$featuresCard3;

                var bgColor = (0,helpers/* hexToRGB */.$W)(item === null || item === void 0 ? void 0 : item.cardColor);
                var showCard = 3;

                if ((secData === null || secData === void 0 ? void 0 : (_secData$featuresCard3 = secData.featuresCard) === null || _secData$featuresCard3 === void 0 ? void 0 : _secData$featuresCard3.length) <= 3) {
                  showCard = 4;
                }

                return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                  item: true,
                  xs: 12,
                  sm: 6,
                  md: showCard,
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "".concat((highlights_module_default()).test_card),
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (highlights_module_default()).test_card_circle_1,
                      style: {
                        backgroundColor: "".concat(item === null || item === void 0 ? void 0 : item.cardColor)
                      }
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (highlights_module_default()).test_card_circle_2,
                      style: {
                        backgroundColor: "rgba(".concat(bgColor, ", .8)")
                      }
                    }), (item === null || item === void 0 ? void 0 : item.cardIconSrc) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (highlights_module_default()).test_icon,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        src: item === null || item === void 0 ? void 0 : item.cardIconSrc
                      })
                    }), (item === null || item === void 0 ? void 0 : item.cardTitle) && /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                      className: (highlights_module_default()).test_title,
                      children: item === null || item === void 0 ? void 0 : item.cardTitle
                    }), (item === null || item === void 0 ? void 0 : item.cardDescription) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (highlights_module_default()).test_desc,
                      children: item === null || item === void 0 ? void 0 : item.cardDescription
                    })]
                  })
                }, i);
              })
            })]
          })
        }, i);
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
  });
};
/* harmony default export */ var section_highlights = ((/* unused pure expression or super */ null && (LeadSectionHighlights)));
// EXTERNAL MODULE: ./_modules/lead/components/section_form/form.module.scss
var form_module = __webpack_require__(75343);
var form_module_default = /*#__PURE__*/__webpack_require__.n(form_module);
;// CONCATENATED MODULE: ./_modules/lead/components/section_form/index.jsx




var LeadSectionForm = function LeadSectionForm(_ref) {
  var pageData = _ref.pageData;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    id: "form",
    className: (form_module_default()).form_section,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (form_module_default()).form_wrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_form.LeadForm, {
          pageData: pageData
        })
      })
    })
  });
};
/* harmony default export */ var section_form = ((/* unused pure expression or super */ null && (LeadSectionForm)));
// EXTERNAL MODULE: ./_modules/lead/components/form/index.jsx
var components_form = __webpack_require__(57208);
;// CONCATENATED MODULE: ./_modules/lead/components/index.js








/***/ }),

/***/ 2511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ searchPopupState; }
/* harmony export */ });
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2804);

var searchPopupState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
  key: "searchpopup",
  "default": {
    open: false,
    enablePopup: true,
    isOpenHomePagePopup: false
  }
});

/***/ }),

/***/ 52006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _live_search_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80375);
/* harmony import */ var _live_search_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_live_search_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var LiveSearch = function LiveSearch(_ref) {
  var _ref$results = _ref.results,
      results = _ref$results === void 0 ? [] : _ref$results,
      renderItem = _ref.renderItem,
      input = _ref.input,
      setResult = _ref.setResult,
      value = _ref.value,
      onChange = _ref.onChange,
      onSelect = _ref.onSelect,
      customClasses = _ref.customClasses,
      placeholder = _ref.placeholder;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(-1),
      focusedIndex = _useState[0],
      setFocusedIndex = _useState[1];

  var resultContainer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      showResults = _useState2[0],
      setShowResults = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""),
      defaultValue = _useState3[0],
      setDefaultValue = _useState3[1];

  var inputFocus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

  var handleSelection = function handleSelection(selectedIndex) {
    var selectedItem = results[selectedIndex];
    if (!selectedItem) return resetSearchComplete();
    onSelect && onSelect(selectedItem);
    resetSearchComplete();
    setDefaultValue(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.title);
  };

  var resetSearchComplete = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    setFocusedIndex(-1);
    setShowResults(false);
  }, []);

  var handleKeyDown = function handleKeyDown(e) {
    var key = e.key;
    var nextIndexCount = 0; // move down

    if (key === "ArrowDown") nextIndexCount = (focusedIndex + 1) % results.length; // move up

    if (key === "ArrowUp") nextIndexCount = (focusedIndex + results.length - 1) % results.length; // hide search results

    if (key === "Escape") {
      resetSearchComplete();
    } // select the current item


    if (key === "Enter") {
      e.preventDefault();
      handleSelection(focusedIndex);
    }

    setFocusedIndex(nextIndexCount);
  };

  var handleChange = function handleChange(e) {
    setDefaultValue(e.target.value);
    onChange && onChange(e);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!resultContainer.current) return;
    resultContainer.current.scrollIntoView({
      block: "center"
    });
  }, [focusedIndex]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (results.length > 0 && !showResults) setShowResults(true);
    if (results.length <= 0) setShowResults(false);
  }, [results]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (value) setDefaultValue(value);
  }, [value]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var checkIfClickedOutside = function checkIfClickedOutside(e) {
      if (showResults && wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowResults(false);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);
    return function () {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [showResults]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    inputFocus.current.focus();
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    tabIndex: 1,
    onKeyDown: handleKeyDown,
    className: "".concat((_live_search_module_scss__WEBPACK_IMPORTED_MODULE_2___default().wrapper)),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
      value: defaultValue,
      ref: inputFocus,
      onChange: handleChange,
      type: "text",
      className: "".concat((_live_search_module_scss__WEBPACK_IMPORTED_MODULE_2___default().input)),
      placeholder: placeholder ? placeholder : "Search your query"
    }), showResults && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: "".concat((_live_search_module_scss__WEBPACK_IMPORTED_MODULE_2___default().option_wrapper)),
      ref: wrapperRef,
      children: results.map(function (item, index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
          onMouseDown: function onMouseDown() {
            return handleSelection(index);
          },
          ref: index === focusedIndex ? resultContainer : null,
          style: {
            backgroundColor: index === focusedIndex ? "#f7f7fe" : "",
            color: index === focusedIndex ? "#f47f20" : "inherit"
          },
          className: "".concat((_live_search_module_scss__WEBPACK_IMPORTED_MODULE_2___default().option)),
          children: renderItem(item)
        }, index);
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (LiveSearch);

/***/ }),

/***/ 21197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _skeleton_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2385);
/* harmony import */ var _skeleton_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_skeleton_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["width", "height", "className", "style", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Skeleton = function Skeleton(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      style = _ref.style,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "rectangular" : _ref$variant,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", _objectSpread({
    className: "".concat((_skeleton_module_scss__WEBPACK_IMPORTED_MODULE_4___default().skeleton), " ").concat(className ? className : ""),
    style: _objectSpread(_objectSpread({
      width: width,
      height: height
    }, variant == "circle" && {
      borderRadius: "50%"
    }), style)
  }, props));
};

/* harmony default export */ __webpack_exports__["Z"] = (Skeleton);

/***/ }),

/***/ 46865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FixedPopup": function() { return /* binding */ FixedPopup; }
/* harmony export */ });
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72145);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86893);
/* harmony import */ var _fixed_popup_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57388);
/* harmony import */ var _fixed_popup_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_fixed_popup_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);









var Modal = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return __webpack_require__.e(/* import() */ 420).then(__webpack_require__.bind(__webpack_require__, 80420));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(80420)];
    }
  }
});
var VirtualOfficePopup = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return __webpack_require__.e(/* import() */ 1049).then(__webpack_require__.bind(__webpack_require__, 61049));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(61049)];
    }
  }
});
var FixedPopup = function FixedPopup() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var handleOpen = function handleOpen() {
    return setOpen(true);
  };

  var handleClose = function handleClose() {
    return setOpen(false);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      onClick: handleOpen,
      className: (_fixed_popup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().fixed_popup_container),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        layout: "responsive",
        width: 94,
        height: 94,
        placeholder: "blur",
        blurDataURL: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getAssets */ .Vh)("assets/Virtual-Office.webp"),
        src: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getAssets */ .Vh)("assets/Virtual-Office.webp"),
        alt: "Virtual-Office"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Modal, {
      "aria-labelledby": "transition-modal-title",
      "aria-describedby": "transition-modal-description",
      open: open,
      onClose: handleClose,
      closeAfterTransition: true,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: "modal sm",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("button", {
          type: "button",
          style: {
            position: "absolute",
            top: "24px",
            right: "10px"
          },
          className: "cross_icon",
          onClick: handleClose,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_6__/* .FiX */ .q5L, {})
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(VirtualOfficePopup, {})]
      })
    })]
  });
};
/* harmony default export */ __webpack_exports__["default"] = (FixedPopup);

/***/ }),

/***/ 71634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FooterOne": function() { return /* binding */ FooterOne; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90116);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86893);
/* harmony import */ var _footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8213);
/* harmony import */ var _footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);










var Collapse = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return __webpack_require__.e(/* import() */ 6138).then(__webpack_require__.bind(__webpack_require__, 46138));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(46138)];
    }
  }
});
var SocialLinks = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(6158), __webpack_require__.e(6575)]).then(__webpack_require__.bind(__webpack_require__, 6575));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(6575)];
    }
  }
});

var address = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
  children: ["Suite 98 Level 3, 515 Kent Street, ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("br", {}), "Sydney, NSW 2000"]
});

var data = [{
  id: 1,
  name: "About UniSearch",
  children: [{
    link: "/who-we-are",
    title: "Who We Are"
  }, {
    link: "/vision-mission",
    title: "Vision & Mission"
  }, {
    link: "/team",
    title: "Team"
  }, {
    link: "/contact-us",
    title: "Contact Us"
  }]
}, {
  id: 2,
  name: "Join Our Team",
  children: [{
    link: "https://mentor.myunisearch.com",
    title: "Become a Mentor",
    linkOutside: true
  }, {
    link: "https://counsellor.myunisearch.com",
    title: "Counsellor Login",
    linkOutside: true
  }, {
    link: "https://university.myunisearch.com",
    title: "University Login",
    linkOutside: true
  }, {
    link: "/career",
    title: "Career"
  }]
}, {
  id: 3,
  name: "Key Features",
  children: [{
    link: "/explore-university",
    title: "Study Abroad"
  }, {
    link: "/elearning",
    title: "Online Learning"
  }, {
    link: "/accommodation",
    title: "Accommodation"
  }, {
    link: "#",
    title: "Internships",
    type: "p",
    coming: true
  }]
}, {
  id: 4,
  name: "Connect with Us",
  children: [{
    link: "#",
    type: "jsx",
    title: address
  }],
  members: {
    title: "Members",
    logos: ["/assets/members-logo/nafsa-logo-.webp"]
  }
}];
var FooterOne = function FooterOne(props) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      openItem = _useState[0],
      setOpen = _useState[1];

  var handleCollapse = function handleCollapse(val) {
    var item = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(openItem);

    var index = item.indexOf(val);

    if (index > -1) {
      item.splice(index, 1);
    } else {
      item.push(val);
    }

    setOpen(item);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [props.footer_with_evaluation && !props.userData && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("section", {
      className: (_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().section_evaluation),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: (_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().evaluation_wrapper),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: "".concat((_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title_wrapper)),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("h2", {
              className: "".concat((_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title), " fw400"),
              children: ["Ready to Get", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                className: "".concat((_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().mark), " mark "),
                children: "Started?"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
              className: "".concat((_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().sub_title), " sub_title"),
              children: "Help us find the best study abroad courses and universities for you with just a few simple steps."
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            legacyBehavior: true,
            href: "/profile/evaluation",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
              className: "btn btn-bg btn-white",
              children: "Profile Evaluation"
            })
          })]
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("footer", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: "".concat((_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().footer_main), " ").concat(props.footer_with_evaluation && !props.userData ? (_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().padding_big) : ""),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
          className: "container-extend container",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: (_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().row),
            children: data.map(function (item) {
              var _item$members, _item$members2, _item$members2$logos, _item$members3, _item$members3$logos;

              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("h5", {
                  className: (_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().fnav_title),
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                    children: item.name
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("ul", {
                  className: (_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().fnav_list),
                  children: item.children.map(function (child, i) {
                    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("li", {
                      children: child.type == "jsx" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(SocialLinks, {})
                      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                        children: child.type == "p" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("span", {
                          className: "relative",
                          children: [child.title, child.coming && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                            className: "uni-tooltip",
                            children: "Coming Soon"
                          })]
                        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                          children: child.linkOutside ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                            href: child.link,
                            target: "_blank",
                            rel: "nofollow",
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                              children: child.title
                            })
                          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            legacyBehavior: true,
                            href: child.link,
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                                children: child.title
                              })
                            })
                          })
                        })
                      })
                    }, i);
                  })
                }), (item === null || item === void 0 ? void 0 : item.members) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("h5", {
                    className: "".concat((_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().fnav_title), " !mb-2"),
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                      children: item === null || item === void 0 ? void 0 : (_item$members = item.members) === null || _item$members === void 0 ? void 0 : _item$members.title
                    })
                  }), (item === null || item === void 0 ? void 0 : (_item$members2 = item.members) === null || _item$members2 === void 0 ? void 0 : (_item$members2$logos = _item$members2.logos) === null || _item$members2$logos === void 0 ? void 0 : _item$members2$logos.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
                    className: "flex gap-2",
                    children: item === null || item === void 0 ? void 0 : (_item$members3 = item.members) === null || _item$members3 === void 0 ? void 0 : (_item$members3$logos = _item$members3.logos) === null || _item$members3$logos === void 0 ? void 0 : _item$members3$logos.map(function (member, i) {
                      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                        src: member,
                        width: 70,
                        height: 70,
                        alt: "partner"
                      }, i);
                    })
                  })]
                })]
              }, item.id);
            })
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: "".concat((_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().footer_main), " ").concat((_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().mobile), " ").concat(props.footer_with_evaluation && !props.userData ? (_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().padding_big) : ""),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
          className: "container-extend",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: (_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().row),
            children: data.map(function (item) {
              var _item$members4, _item$members5, _item$members5$logos, _item$members6, _item$members6$logos;

              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("h5", {
                  className: (_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().fnav_title),
                  onClick: function onClick(e) {
                    return handleCollapse(item.id);
                  },
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                    children: item.name
                  }), openItem.indexOf(item.id) > -1 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_7__/* .FiChevronUp */ .rH8, {}) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_7__/* .FiChevronDown */ .bTu, {})]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(Collapse, {
                  "in": openItem.indexOf(item.id) > -1,
                  timeout: "auto",
                  unmountOnExit: true,
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("ul", {
                    className: (_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().fnav_list),
                    children: item.children.map(function (child, i) {
                      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("li", {
                        children: child.type == "jsx" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(SocialLinks, {})
                        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                          children: child.type == "p" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("span", {
                            className: "relative",
                            children: [child.title, child.coming && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                              className: "uni-tooltip",
                              children: "Coming Soon"
                            })]
                          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                            children: child.linkOutside ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                              href: child.link,
                              target: "_blank",
                              rel: "nofollow",
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                                children: child.title
                              })
                            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                              legacyBehavior: true,
                              href: child.link,
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                                  children: child.title
                                })
                              })
                            })
                          })
                        })
                      }, i);
                    })
                  }), (item === null || item === void 0 ? void 0 : item.members) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("h5", {
                      className: "".concat((_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().fnav_title), " !mb-2"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                        children: item === null || item === void 0 ? void 0 : (_item$members4 = item.members) === null || _item$members4 === void 0 ? void 0 : _item$members4.title
                      })
                    }), (item === null || item === void 0 ? void 0 : (_item$members5 = item.members) === null || _item$members5 === void 0 ? void 0 : (_item$members5$logos = _item$members5.logos) === null || _item$members5$logos === void 0 ? void 0 : _item$members5$logos.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
                      className: "flex gap-2",
                      children: item === null || item === void 0 ? void 0 : (_item$members6 = item.members) === null || _item$members6 === void 0 ? void 0 : (_item$members6$logos = _item$members6.logos) === null || _item$members6$logos === void 0 ? void 0 : _item$members6$logos.map(function (member, i) {
                        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                          src: member,
                          width: 70,
                          height: 70,
                          alt: "member"
                        }, i);
                      })
                    })]
                  })]
                })]
              }, item.id);
            })
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: (_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().footer_bottom),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
          className: "container",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: (_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().container),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
              className: (_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().bottom_left),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("p", {
                children: ["Copyright \xA9 ", new Date().getFullYear(), " UniSearch \u2013 All rights reserved."]
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
              className: (_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().bottom_right),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                legacyBehavior: true,
                href: "/terms-and-conditions",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  children: "Terms of Service"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("span", {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                  className: (_footer_one_module_scss__WEBPACK_IMPORTED_MODULE_6___default().fiiter_link),
                  children: " Developed by :"
                }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    padding: 0,
                    opacity: "100%"
                  },
                  href: "https://www.m4yours.com/",
                  target: "_blank",
                  rel: "noopener noreferrer nofollow",
                  children: "M4YOURS IT"
                })]
              })]
            })]
          })
        })
      })]
    })]
  });
};
/* harmony default export */ __webpack_exports__["default"] = (FooterOne);

/***/ }),

/***/ 98781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AccountMenu": function() { return /* binding */ AccountMenu; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17674);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72145);
/* harmony import */ var _recoil_actions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8612);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _account_menu_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15063);
/* harmony import */ var _account_menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_account_menu_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);










var Menu = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function () {
  return __webpack_require__.e(/* import() */ 6683).then(__webpack_require__.bind(__webpack_require__, 56683));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(56683)];
    }
  }
});
var AccountMenu = function AccountMenu(_ref) {
  var _userInfo$firstName, _userInfo$email;

  var userInfo = _ref.userInfo;
  var authActions = (0,_recoil_actions__WEBPACK_IMPORTED_MODULE_1__/* .useAuthActions */ .X$)();

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_4__.useState(null),
      _React$useState2 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var open = Boolean(anchorEl); //handle open

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
    document.body.classList.add("popOpen");
  }; //handle close


  var handleClose = function handleClose() {
    setAnchorEl(null);
    document.body.classList.remove("popOpen");
  }; //Logout


  var logout = function logout() {
    if (userInfo && (userInfo.userTypeSlug == "mentor" || userInfo.userTypeSlug == "student")) {
      // authService.logout("/signin");
      authActions.logout("signin");
    } else {
      // authService.logout("/partner-login");
      authActions.logout("partner-login");
    }
  }; //render Profile Image


  var renderProfileImage = function renderProfileImage(data) {
    if (data && data.userTypeSlug == "university") {
      var _data$university, _data$university$logo, _data$firstName;

      var logo = data === null || data === void 0 ? void 0 : (_data$university = data.university) === null || _data$university === void 0 ? void 0 : (_data$university$logo = _data$university.logo) === null || _data$university$logo === void 0 ? void 0 : _data$university$logo.src;
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
        children: logo && logo != "" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("img", {
          src: logo,
          alt: "avatar"
        }) : data === null || data === void 0 ? void 0 : (_data$firstName = data.firstName) === null || _data$firstName === void 0 ? void 0 : _data$firstName.charAt(0)
      });
    } else if (data && (data.userTypeSlug == "student" || data.userTypeSlug == "mentor")) {
      var _data$firstName2;

      var ProfileImage = data === null || data === void 0 ? void 0 : data.profileImageSrc;
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
        children: ProfileImage && ProfileImage != "" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("img", {
          src: ProfileImage,
          alt: "avatar"
        }) : data && (data === null || data === void 0 ? void 0 : (_data$firstName2 = data.firstName) === null || _data$firstName2 === void 0 ? void 0 : _data$firstName2.charAt(0))
      });
    } else if (data && data.userTypeSlug == "counsellor") {
      var _data$firstName3;

      var _ProfileImage = data === null || data === void 0 ? void 0 : data.profileImageSrc;

      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
        children: _ProfileImage && _ProfileImage != "" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("img", {
          src: _ProfileImage,
          alt: "avatar"
        }) : data && (data === null || data === void 0 ? void 0 : (_data$firstName3 = data.firstName) === null || _data$firstName3 === void 0 ? void 0 : _data$firstName3.charAt(0))
      });
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("img", {
      src: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getAssets */ .Vh)("assets/student-avatar-small.png"),
      alt: "Avatar"
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      onClick: handleClick,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: (_account_menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default().profile_wrapper),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_account_menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default().name_wrapper)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_account_menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default().image_wrapper),
          children: renderProfileImage(userInfo)
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Menu, {
      anchorEl: anchorEl,
      open: open,
      onClose: handleClose,
      className: "ProfileDropdown",
      transformOrigin: {
        horizontal: "right",
        vertical: "top"
      },
      anchorOrigin: {
        horizontal: "right",
        vertical: "bottom"
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("li", {
        className: (_account_menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default().profile_dropdown_wrapper),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "".concat((_account_menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default().profile_wrapper), " ").concat((_account_menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default().profile_info), " "),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: (_account_menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default().image_wrapper),
            children: renderProfileImage(userInfo)
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: (_account_menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default().name_wrapper),
            children: userInfo && userInfo.userTypeSlug && (userInfo.userTypeSlug == "student" || userInfo.userTypeSlug == "mentor" || userInfo.userTypeSlug == "counsellor") && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                className: (_account_menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default().name),
                children: (_userInfo$firstName = userInfo === null || userInfo === void 0 ? void 0 : userInfo.firstName) !== null && _userInfo$firstName !== void 0 ? _userInfo$firstName : ""
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                className: (_account_menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default().id),
                children: (_userInfo$email = userInfo === null || userInfo === void 0 ? void 0 : userInfo.email) !== null && _userInfo$email !== void 0 ? _userInfo$email : ""
              })]
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_account_menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default().divider)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("ul", {
          className: (_account_menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default().menu_list),
          children: [userInfo && userInfo.userTypeSlug && userInfo.userTypeSlug == "student" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                legacyBehavior: true,
                href: "/app/student",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                  className: (_account_menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default().link),
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
                    children: "My Dashboard"
                  })
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                legacyBehavior: true,
                href: "/app/student/profile",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                  className: (_account_menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default().link),
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
                    children: "My Profile"
                  })
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                legacyBehavior: true,
                href: "/app/student/settings",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                  className: (_account_menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default().link),
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
                    children: "Account Settings"
                  })
                })
              })
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            onClick: logout,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
              className: (_account_menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default().link),
              children: "Sign Out"
            })
          })]
        })]
      })
    })]
  });
};
/* harmony default export */ __webpack_exports__["default"] = (AccountMenu);

/***/ }),

/***/ 14711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _recoil_state__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89093);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5434);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2804);
/* harmony import */ var _compare_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78245);
/* harmony import */ var _compare_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_compare_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);









var CompareComponent = function CompareComponent() {
  var userDatas = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(_recoil_state__WEBPACK_IMPORTED_MODULE_0__/* .authAtom */ .L4);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(),
      userData = _useState[0],
      setUserData = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0),
      compareState = _useState2[0],
      coutnCompare = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (userDatas) {
      setUserData(userDatas);
    }
  }, [userDatas]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (userData && (userData.compareCourseList || userData.compareUniversityList)) {
      var compNum = 0;

      if (userData.compareCourseList && userData.compareCourseList.length) {
        var _userData$compareCour;

        compNum += (_userData$compareCour = userData.compareCourseList.length) !== null && _userData$compareCour !== void 0 ? _userData$compareCour : 0;
      }

      if (userData.compareUniversityList && userData.compareUniversityList.length) {
        var _userData$compareUniv;

        compNum += (_userData$compareUniv = userData.compareUniversityList.length) !== null && _userData$compareUniv !== void 0 ? _userData$compareUniv : 0;
      }

      coutnCompare(compNum);
    } else {
      coutnCompare(0);
    }
  }, [userData]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
    className: (_compare_module_scss__WEBPACK_IMPORTED_MODULE_5___default().compare_dropdown_parent),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: (_compare_module_scss__WEBPACK_IMPORTED_MODULE_5___default().compare),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_6__/* .MdSwapCalls */ .mzl, {
        style: {
          transform: "rotate(90deg)"
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
        className: (_compare_module_scss__WEBPACK_IMPORTED_MODULE_5___default().compare_num),
        children: compareState > 9 ? "9+" : compareState
      })]
    }), compareState > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: (_compare_module_scss__WEBPACK_IMPORTED_MODULE_5___default().compare_dropdown),
      children: [userData && userData.compareUniversityList && userData.compareUniversityList.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/compare/university",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
          className: (_compare_module_scss__WEBPACK_IMPORTED_MODULE_5___default().comp_name),
          children: "University"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
          className: (_compare_module_scss__WEBPACK_IMPORTED_MODULE_5___default().comp_count),
          children: parseInt(userData && userData.compareUniversityList.length)
        })]
      }), userData && userData.compareCourseList && userData.compareCourseList.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/compare/course",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
          className: (_compare_module_scss__WEBPACK_IMPORTED_MODULE_5___default().comp_name),
          children: "Course"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
          className: (_compare_module_scss__WEBPACK_IMPORTED_MODULE_5___default().comp_count),
          children: parseInt(userData && userData.compareCourseList.length)
        })]
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (CompareComponent);

/***/ }),

/***/ 86888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _recoil_state__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89093);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5434);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2804);
/* harmony import */ var _favorite_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32993);
/* harmony import */ var _favorite_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_favorite_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);









var FavoriteComponent = function FavoriteComponent() {
  var userDatas = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(_recoil_state__WEBPACK_IMPORTED_MODULE_0__/* .authAtom */ .L4);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(),
      userData = _useState[0],
      setUserData = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0),
      favrouteState = _useState2[0],
      coutnFavroute = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (userDatas) {
      setUserData(userDatas);
    }
  }, [userDatas]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (userData && (userData.favoriteCourseList || userData.favoriteUniversityList)) {
      var fevNum = 0;

      if (userData.favoriteCourseList && userData.favoriteCourseList.length) {
        var _userData$favoriteCou;

        fevNum += (_userData$favoriteCou = userData.favoriteCourseList.length) !== null && _userData$favoriteCou !== void 0 ? _userData$favoriteCou : 0;
      }

      if (userData.favoriteUniversityList && userData.favoriteUniversityList.length) {
        var _userData$favoriteUni;

        fevNum += (_userData$favoriteUni = userData.favoriteUniversityList.length) !== null && _userData$favoriteUni !== void 0 ? _userData$favoriteUni : 0;
      }

      coutnFavroute(fevNum);
    } else {
      coutnFavroute(0);
    }
  }, [userData]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
    className: (_favorite_module_scss__WEBPACK_IMPORTED_MODULE_5___default().compare_dropdown_parent),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: (_favorite_module_scss__WEBPACK_IMPORTED_MODULE_5___default().compare),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_6__/* .MdFavoriteBorder */ .iqB, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
        className: (_favorite_module_scss__WEBPACK_IMPORTED_MODULE_5___default().compare_num),
        children: favrouteState && (favrouteState > 9 ? "9+" : favrouteState)
      })]
    }), favrouteState > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: (_favorite_module_scss__WEBPACK_IMPORTED_MODULE_5___default().compare_dropdown),
      children: [userData && userData.favoriteUniversityList && userData.favoriteUniversityList.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/app/student/favorite/university",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
          className: (_favorite_module_scss__WEBPACK_IMPORTED_MODULE_5___default().comp_name),
          children: "University"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
          className: (_favorite_module_scss__WEBPACK_IMPORTED_MODULE_5___default().comp_count),
          children: parseInt(userData && userData.favoriteUniversityList.length)
        })]
      }), userData && userData.favoriteCourseList && userData.favoriteCourseList.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/app/student/favorite/courses",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
          className: (_favorite_module_scss__WEBPACK_IMPORTED_MODULE_5___default().comp_name),
          children: "Course"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
          className: (_favorite_module_scss__WEBPACK_IMPORTED_MODULE_5___default().comp_count),
          children: parseInt(userData && userData.favoriteCourseList.length)
        })]
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (FavoriteComponent);

/***/ }),

/***/ 26204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HeaderCampaign": function() { return /* binding */ HeaderCampaign; }
/* harmony export */ });
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72145);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98547);
/* harmony import */ var _header_campaign_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29343);
/* harmony import */ var _header_campaign_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_header_campaign_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);






var HeaderCampaign = function HeaderCampaign() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("header", {
    className: (_header_campaign_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header_campaign),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
      legacyBehavior: true,
      href: "/",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_svg__WEBPACK_IMPORTED_MODULE_3__/* .ReactSVG */ .Q, {
          src: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getAssets */ .Vh)("assets/icons/logo_dark.svg"),
          className: (_header_campaign_module_scss__WEBPACK_IMPORTED_MODULE_5___default().logo)
        })
      })
    })
  });
};
/* harmony default export */ __webpack_exports__["default"] = (HeaderCampaign);

/***/ }),

/***/ 78599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HeaderMobileOne": function() { return /* binding */ HeaderMobileOne; },
  "default": function() { return /* binding */ header_mobile; }
});

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-pro-sidebar/dist/index.es.js
var index_es = __webpack_require__(40979);
// EXTERNAL MODULE: ./node_modules/react-pro-sidebar/dist/css/styles.css
var styles = __webpack_require__(41360);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./_unisearch/theme/layout/headers/header_mobile/components/header_mobile_top/header_mobile_top.module.scss
var header_mobile_top_module = __webpack_require__(65158);
var header_mobile_top_module_default = /*#__PURE__*/__webpack_require__.n(header_mobile_top_module);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_unisearch/theme/layout/headers/header_mobile/components/header_mobile_top/index.jsx










var HeaderMobileTop = function HeaderMobileTop(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (header_mobile_top_module_default()).top_nav,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: (header_mobile_top_module_default()).active,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "/",
              children: "Study"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "/elearning",
              children: "eLearning "
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "/accommodation",
              children: "Accommodation"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "#",
              children: "Jobs"
            })
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (header_mobile_top_module_default()).mainHeader_wrapper,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (header_mobile_top_module_default()).mainHeader,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (header_mobile_top_module_default()).company_logo,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "/",
              className: (header_mobile_top_module_default()).logo,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: (0,helpers/* getAssets */.Vh)("assets/logo-beta.webp"),
                alt: "UniSearch Logo",
                blurDataURL: (0,helpers/* getAssets */.Vh)("assets/logo-beta.webp"),
                placeholder: "blur",
                width: 186,
                height: 30
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (header_mobile_top_module_default()).right_options,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              legacyBehavior: true,
              href: "/profile/evaluation",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: "btn btn-primary",
                style: {
                  padding: "5px",
                  fontSize: "12px"
                },
                children: "Profile Evaluation"
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FiX */.q5L, {
            onClick: function onClick() {
              props.setOpen(false); // document.body.classList.remove("popOpen");
            },
            className: (header_mobile_top_module_default()).cross_icon
          })]
        })
      })
    })]
  });
};

/* harmony default export */ var header_mobile_top = (HeaderMobileTop);
;// CONCATENATED MODULE: ./_unisearch/theme/layout/headers/header_mobile/index.jsx








var HeaderMobileOne = function HeaderMobileOne(props) {
  var _props$menuData = props === null || props === void 0 ? void 0 : props.menuData,
      menuList = _props$menuData.menuList,
      isLoading = _props$menuData.isLoading;

  var menuTree = function menuTree(menuListItem) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* ProSidebar */.M7, {
      className: "MobileSideMenu",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* Menu */.v2, {
        children: menuListItem && menuListItem.length > 0 && menuListItem.map(function (menuItem, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
            children: menuItem.children.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
              children: menuItem.isGroup === 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* SubMenu */.Wd, {
                title: menuItem.title,
                children: menuItem.children && menuItem.children.length > 0 && menuItem.children.map(function (groupHead, groupIndex) {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* MenuItem */.sN, {
                      style: {
                        fontWeight: 500
                      },
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                        legacyBehavior: true,
                        href: groupHead.link,
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                          children: groupHead.title
                        })
                      })
                    }), groupHead.children && groupHead.children.length > 0 && groupHead.children.map(function (groupChild, childIndex) {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* MenuItem */.sN, {
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                            legacyBehavior: true,
                            href: groupChild.link,
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                              children: groupChild.title
                            })
                          })
                        })
                      }, "menuItemChild".concat(childIndex).concat(groupChild.title));
                    })]
                  }, "menuItemGroup".concat(groupIndex).concat(groupHead.title));
                })
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* SubMenu */.Wd, {
                title: menuItem.title,
                children: menuItem.children && menuItem.children.length > 0 && menuTree(menuItem.children)
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* MenuItem */.sN, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: menuItem.link,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  children: menuItem.title
                })
              })
            })
          }, "menuItem".concat(index).concat(menuItem.title));
        })
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(header_mobile_top, {
      setOpen: props.setOpen
    }), menuTree(menuList)]
  });
};
/* harmony default export */ var header_mobile = (HeaderMobileOne);

/***/ }),

/***/ 6195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HeaderOne": function() { return /* binding */ HeaderOne; }
/* harmony export */ });
/* harmony import */ var _unisearch_common_skeleton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21197);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72145);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8193);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86893);
/* harmony import */ var react_icons_io__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(51649);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5434);
/* harmony import */ var _hooks_useWindowDimensions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14418);
/* harmony import */ var _header_one_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(25858);
/* harmony import */ var _header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31955);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);
















var CompareComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 14711));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(14711)];
    }
  }
});
var FavoriteComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 86888));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(86888)];
    }
  }
});
var AccountMenu = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98781));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(98781)];
    }
  }
});
var Tooltip = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(5551), __webpack_require__.e(1286), __webpack_require__.e(377)]).then(__webpack_require__.bind(__webpack_require__, 16539));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(16539)];
    }
  }
});
var SwipeableDrawer = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1707), __webpack_require__.e(2377)]).then(__webpack_require__.bind(__webpack_require__, 82377));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(82377)];
    }
  }
});
var HeaderMobileOne = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 78599));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(78599)];
    }
  }
});
var HeaderSearch = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 14890));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(14890)];
    }
  }
});
var SocialLinks = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(6158), __webpack_require__.e(6575)]).then(__webpack_require__.bind(__webpack_require__, 6575));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(6575)];
    }
  }
});
var HeaderOne = function HeaderOne(_ref) {
  var _Cookies$get, _contactInfo$defaultC, _contactInfo$defaultC2;

  var menuData = _ref.menuData,
      userData = _ref.userData,
      isHeaderSticky = _ref.isHeaderSticky;
  var menuList = menuData.menuList,
      isLoading = menuData.isLoading;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)(),
      asPath = _useRouter.asPath;

  var _useWindowDimensions = (0,_hooks_useWindowDimensions__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(),
      width = _useWindowDimensions.width;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var toggleDrawer = function toggleDrawer(newOpen) {
    return function () {
      setOpen(newOpen);
    };
  };

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)((_Cookies$get = js_cookie__WEBPACK_IMPORTED_MODULE_8__/* ["default"].get */ .Z.get("default_country")) !== null && _Cookies$get !== void 0 ? _Cookies$get : "au"),
      defaultCountryCode = _useState2[0],
      setDefaultCountryCode = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    setTimeout(function () {
      if (typeof js_cookie__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z == "object") {
        if (js_cookie__WEBPACK_IMPORTED_MODULE_8__/* ["default"].get */ .Z.get("default_country")) {
          setDefaultCountryCode(js_cookie__WEBPACK_IMPORTED_MODULE_8__/* ["default"].get */ .Z.get("default_country"));
        }
      }
    }, 3000);
  }, [defaultCountryCode]);
  var contactInfo = {
    bd: "+880 1673090958",
    au: "+61 450637122" // in: "+61 450637122",

  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("header", {
      id: "sticky",
      className: "sticky z-[1100] top-0" // style={{ top: isHeaderSticky ? "0" : null }}
      ,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().topHeader),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: "container-extend",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
            className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().top_row),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
              className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().left_cel),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("ul", {
                className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().uni_info),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("li", {
                  className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().top_phone_num),
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("a", {
                    href: "tel:".concat((_contactInfo$defaultC = contactInfo[defaultCountryCode]) !== null && _contactInfo$defaultC !== void 0 ? _contactInfo$defaultC : "+61 450637122"),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_11__/* .FiPhone */ .tUt, {
                      style: {
                        fontSize: "16px",
                        strokeWidth: 1,
                        color: "#f47f20"
                      }
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                      children: (_contactInfo$defaultC2 = contactInfo[defaultCountryCode]) !== null && _contactInfo$defaultC2 !== void 0 ? _contactInfo$defaultC2 : "+61 450637122"
                    })]
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("li", {
                  className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().top_email_address),
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("a", {
                    href: "mailto:info@myunisearch.com",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_11__/* .FiMail */ .Imn, {
                      style: {
                        fontSize: "18px",
                        strokeWidth: 1,
                        color: "#f47f20"
                      }
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                      children: "info@myunisearch.com"
                    })]
                  })
                })]
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
              className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().top_nav),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("ul", {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("li", {
                  className: !asPath.startsWith("/elearning") && !asPath.startsWith("/accommodation") && !asPath.startsWith("/") && !asPath.startsWith("/jobs") ? (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().active) : "",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                    href: "/",
                    children: "Study"
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("li", {
                  className: asPath.startsWith("/elearning") ? (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().active) : "",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                    href: "/elearning",
                    children: "eLearning"
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("li", {
                  className: asPath.startsWith("/accommodation") ? (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().active) : "",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("a", {
                    href: "/accommodation",
                    children: "Accommodation"
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(Tooltip, {
                  title: "Coming Soon",
                  arrow: true,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("li", {
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                      href: "#",
                      children: "Internships"
                    })
                  })
                })]
              })
            }), width > 1140 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
              className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().right_cel),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(SocialLinks, {})
            })]
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().mainHeader),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: "container-extend",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
            className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().row),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_12__/* .AiOutlineMenu */ .qTj, {
              className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().menu_icon),
              onClick: function onClick() {
                return setOpen(true);
              }
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
              className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().company_logo),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                href: "/",
                className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().logo),
                style: {
                  display: "inline-block"
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                  src: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getAssets */ .Vh)("assets/logo-beta.webp"),
                  alt: "UniSearch Logo",
                  blurDataURL: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getAssets */ .Vh)("assets/logo-beta.webp"),
                  placeholder: "blur",
                  width: 186,
                  height: 30
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
              className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().main_nav),
              children: [width > 1140 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
                children: isLoading ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_unisearch_common_skeleton__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
                  width: 500,
                  height: 70
                }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("ul", {
                  children: menuList && menuList.length > 0 && menuList.map(function (data, index) {
                    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("li", {
                      className: "".concat(data.isMegaMenu === 1 ? (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().mega) : "", " "),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                        legacyBehavior: true,
                        href: "".concat(data.link),
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("a", {
                          className: "".concat(asPath == data.link ? (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().active) : ""),
                          children: data.title
                        })
                      }), data.children.length > 0 && data.isMegaMenu === 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("ul", {
                        className: "".concat((_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().mega_menu), " menu_menu_parent dropdown_parent"),
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("li", {
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                            className: "container-extend",
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                              className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().mega_col_wrapper),
                              children: data.children.map(function (megaGroup, indexNumber) {
                                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                                  className: "col ".concat((_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().mega_box)),
                                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                                    className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().menu_title),
                                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("h5", {
                                      children: megaGroup.title
                                    })
                                  }), megaGroup.children.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                                    className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().menu_content),
                                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("ul", {
                                      className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().mega_list),
                                      children: megaGroup.children.map(function (groupSubmenu, groupSubmenuIndex) {
                                        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("li", {
                                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                              legacyBehavior: true,
                                              href: "".concat(groupSubmenu.link),
                                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("a", {
                                                className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().menu_sub_title),
                                                children: groupSubmenu.title
                                              })
                                            })
                                          }), groupSubmenu.children.length > 0 && groupSubmenu.children.map(function (item, i) {
                                            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("li", {
                                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                legacyBehavior: true,
                                                href: item.link,
                                                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("a", {
                                                  className: asPath == item.link ? (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().active) : "",
                                                  children: item.title
                                                })
                                              })
                                            }, "subChild".concat(i));
                                          })]
                                        }, "groupSubmenu".concat(groupSubmenuIndex));
                                      })
                                    })
                                  })]
                                }, "mega_group".concat(indexNumber));
                              })
                            })
                          })
                        })
                      }), data.children.length > 0 && data.isMegaMenu !== 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("ul", {
                        className: "dropdown_parent",
                        children: data.children.map(function (defaultChild, childIndex) {
                          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("li", {
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                              legacyBehavior: true,
                              href: defaultChild.link,
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("a", {
                                children: [defaultChild.title, " ", defaultChild.children.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                                  className: "menu-icon",
                                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_13__/* .IoIosArrowForward */ .hjJ, {})
                                })]
                              })
                            }), defaultChild.children.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("ul", {
                              children: defaultChild.children.map(function (stepOneSubmenu, i) {
                                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("li", {
                                  className: "menu-item sub-menu",
                                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    legacyBehavior: true,
                                    href: stepOneSubmenu.link,
                                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("a", {
                                      children: [stepOneSubmenu.title, " ", stepOneSubmenu.children.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                                        className: "menu-icon",
                                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_13__/* .IoIosArrowForward */ .hjJ, {})
                                      })]
                                    })
                                  }), stepOneSubmenu.children.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("ul", {
                                    children: stepOneSubmenu.children.map(function (stepTwoSubmenu, i) {
                                      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("li", {
                                        className: "menu-item sub-menu",
                                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                          legacyBehavior: true,
                                          href: stepTwoSubmenu.link,
                                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("a", {
                                            children: [stepTwoSubmenu.title, " ", stepTwoSubmenu.children.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                                              className: "menu-icon",
                                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_13__/* .IoIosArrowForward */ .hjJ, {})
                                            })]
                                          })
                                        }), stepTwoSubmenu.children.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("ul", {
                                          children: stepTwoSubmenu.children.map(function (stepThreeSubmenu, i) {
                                            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("li", {
                                              className: "menu-item sub-menu",
                                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                legacyBehavior: true,
                                                href: stepThreeSubmenu.link,
                                                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("a", {
                                                  children: stepThreeSubmenu.title
                                                })
                                              })
                                            }, "stepThreeSubmenu".concat(i));
                                          })
                                        })]
                                      }, "stepTwoSubmenu".concat(i));
                                    })
                                  })]
                                }, "stepOneSubmenu".concat(i));
                              })
                            })]
                          }, "defaultChild".concat(childIndex));
                        })
                      })]
                    }, "main_menu".concat(index));
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(HeaderSearch, {
                placeholder: "Search"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
              className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().right_options),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("ul", {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("li", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(FavoriteComponent, {})
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("li", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(CompareComponent, {})
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
                  children: (!userData || Object.keys(userData).length === 0 || userData.userTypeSlug == "student" && !userData.isProfileEvaluated) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("li", {
                    className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btn_profile_evaluation),
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                      legacyBehavior: true,
                      href: "/profile/evaluation",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("a", {
                        className: "btn btn-secondary btn-md",
                        children: "Profile Evaluation"
                      })
                    })
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
                  children: userData && Object.keys(userData).length > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("li", {
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(AccountMenu, {
                      userInfo: userData
                    })
                  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("li", {
                    className: "desktop-icon",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                      legacyBehavior: true,
                      href: "/signin",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("a", {
                        className: "btn btn-outline btn-md ".concat((_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btn_signin)),
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                          className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().open_desktop),
                          children: "Sign In"
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_14__/* .MdPerson */ .Vyx, {
                          className: (_header_one_module_scss__WEBPACK_IMPORTED_MODULE_10___default().open_mobile)
                        })]
                      })
                    })
                  })
                })]
              })
            })]
          })
        })
      })]
    }), width < 1140 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(SwipeableDrawer, {
      anchor: "left",
      open: open,
      onClose: toggleDrawer(false),
      onOpen: toggleDrawer(true),
      disableSwipeToOpen: false,
      ModalProps: {
        keepMounted: true
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(HeaderMobileOne, {
        menuData: menuData,
        setOpen: setOpen
      })
    })]
  });
};
/* harmony default export */ __webpack_exports__["default"] = (HeaderOne);

/***/ }),

/***/ 14890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ header_search; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(91655);
// EXTERNAL MODULE: ./_unisearch/common/live_search/index.jsx
var live_search = __webpack_require__(52006);
// EXTERNAL MODULE: ./_unisearch/helpers/api/index.js
var api = __webpack_require__(85014);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./_modules/study/common/advance_search/advanced_search_dropdown/components/course_form/course_form.module.scss
var course_form_module = __webpack_require__(40716);
var course_form_module_default = /*#__PURE__*/__webpack_require__.n(course_form_module);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 16 modules
var react_select_esm = __webpack_require__(28719);
;// CONCATENATED MODULE: ./_modules/study/common/advance_search/advanced_search_dropdown/components/course_form/select_style.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var selectStyles = {
  control: function control(styles) {
    return _objectSpread(_objectSpread({}, styles), {}, {
      backgroundColor: "#f7f7fe",
      fontSize: "15px",
      padding: "5px",
      border: "0px solid transparent !important",
      borderRadius: "5px",
      boxShadow: "0 !important",
      "&:hover": {
        border: "0px solid transparent !important"
      }
    });
  },
  option: function option(styles, _ref) {
    var isDisabled = _ref.isDisabled,
        isFocused = _ref.isFocused,
        isSelected = _ref.isSelected;
    var color = "#333";
    return _objectSpread(_objectSpread({}, styles), {}, {
      fontSize: "13px",
      // maxHeight: "150px",
      color: isSelected ? "#F47F20" : "#B5B5C3",
      backgroundColor: isSelected ? "#F5F6FC" : isFocused ? "#F5F6FC" : styles.backgroundColor,
      "&:hover": {
        backgroundColor: "#F5F6FC",
        color: "#F47F20"
      },
      cursor: isDisabled ? "not-allowed" : "pointer"
    });
  },
  menuPortal: function menuPortal(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      zIndex: 9999
    });
  },
  menu: function menu(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      zIndex: 9999,
      overflow: "auto",
      marginTop: "10px",
      width: "103%",
      border: 0,
      marginLeft: "-8px"
    });
  },
  placeholder: function placeholder(defaultStyles) {
    return _objectSpread(_objectSpread({}, defaultStyles), {}, {
      color: "#9ca3af;",
      fontSize: "14px"
    });
  }
};
// EXTERNAL MODULE: ./_unisearch/common/skeleton/index.jsx
var skeleton = __webpack_require__(21197);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_modules/study/common/advance_search/advanced_search_dropdown/components/course_form/select_level.jsx










var CourseFormSelectLevel = function CourseFormSelectLevel(_ref) {
  var levelValue = _ref.levelValue,
      setLevelValue = _ref.setLevelValue;

  var _useState = (0,react.useState)([]),
      formatedData = _useState[0],
      setFormatedData = _useState[1];

  var _useState2 = (0,react.useState)(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  (0,react.useEffect)(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var res;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                setLoading(true);
                _context.next = 4;
                return api/* default.get */.Z.get("/public/course-level");

              case 4:
                res = _context.sent;

                if (res.data) {
                  setFormatedData(res.data.map(function (item) {
                    return {
                      label: item.levelName,
                      value: item.slug
                    };
                  }));
                }

                setLoading(false);
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                setLoading(false);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchData();
  }, []);

  var handleSelectChange = function handleSelectChange(newValue) {
    if (newValue === null) {
      setLevelValue(null);
    } else {
      setLevelValue(newValue);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: loading ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
        height: 60
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
      isClearable: true,
      isSearchable: true,
      styles: selectStyles,
      options: formatedData,
      placeholder: "Select Study Level",
      onChange: handleSelectChange,
      value: levelValue
    })
  });
};

/* harmony default export */ var select_level = (CourseFormSelectLevel);
;// CONCATENATED MODULE: ./_modules/study/common/advance_search/advanced_search_dropdown/components/course_form/select_country.jsx










var CourseFormSelectCountry = function CourseFormSelectCountry(_ref) {
  var countryValue = _ref.countryValue,
      setCountryValue = _ref.setCountryValue;

  var _useState = (0,react.useState)([]),
      formatedData = _useState[0],
      setFormatedData = _useState[1];

  var _useState2 = (0,react.useState)(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  (0,react.useEffect)(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var res;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                setLoading(true);
                _context.next = 4;
                return api/* default.get */.Z.get("/public/country/workable");

              case 4:
                res = _context.sent;

                if (res.data) {
                  setFormatedData(res.data.map(function (item) {
                    return {
                      label: item.name,
                      value: item.slug
                    };
                  }));
                }

                setLoading(false);
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                setLoading(false);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchData();
  }, []);

  var handleSelectChange = function handleSelectChange(newValue) {
    if (newValue === null) {
      setCountryValue(null);
    } else {
      setCountryValue(newValue);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: loading ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
        height: 60
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
      isClearable: true,
      isSearchable: true,
      styles: selectStyles,
      options: formatedData,
      placeholder: "Select Country",
      onChange: handleSelectChange,
      value: countryValue
    })
  });
};

/* harmony default export */ var select_country = (CourseFormSelectCountry);
;// CONCATENATED MODULE: ./_modules/study/common/advance_search/advanced_search_dropdown/components/course_form/index.jsx













var AdvancedSearchCourseForm = function AdvancedSearchCourseForm() {
  var _useState = (0,react.useState)(""),
      input = _useState[0],
      setInput = _useState[1];

  var _useState2 = (0,react.useState)(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      levelValue = _useState3[0],
      setLevelValue = _useState3[1];

  var _useState4 = (0,react.useState)(null),
      countryValue = _useState4[0],
      setCountryValue = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      result = _useState5[0],
      setResult = _useState5[1];

  var _useState6 = (0,react.useState)({}),
      selectedValue = _useState6[0],
      setSelectedValue = _useState6[1];

  var handleChange = function handleChange(e) {
    setInput(e.target.value);
  };

  (0,react.useEffect)(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var res;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setLoading(true);
                _context.prev = 1;
                _context.next = 4;
                return api/* default.get */.Z.get("public/specialization/paginate?filter=".concat(input));

              case 4:
                res = _context.sent;

                if (res.data) {
                  setResult(res.data.results);
                  setLoading(false);
                }

                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                setLoading(false);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }));

      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();

    if (input && (input === null || input === void 0 ? void 0 : input.length) > 0) {
      fetchData();
    }
  }, [input]);

  var pushToSearchPage = function pushToSearchPage() {
    if (typeof input === "object") {
      window.location.replace("".concat("https://myunisearch.com", "/search/").concat(input === null || input === void 0 ? void 0 : input.slug));
    }

    if (typeof input === "object" && levelValue) {
      window.location.replace("".concat("https://myunisearch.com", "/search/").concat(input === null || input === void 0 ? void 0 : input.slug, "/").concat(levelValue === null || levelValue === void 0 ? void 0 : levelValue.value));
    }

    if (typeof input === "object" && levelValue && countryValue) {
      window.location.replace("".concat("https://myunisearch.com", "/search/").concat(input === null || input === void 0 ? void 0 : input.slug, "/").concat(levelValue === null || levelValue === void 0 ? void 0 : levelValue.value, "/").concat(countryValue === null || countryValue === void 0 ? void 0 : countryValue.value));
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "grid gap-6",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "".concat((course_form_module_default()).form_wrapper),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(live_search["default"], {
        results: result,
        input: input,
        setResult: setResult,
        value: selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.specializationName,
        placeholder: "Course Subject e.g Computer Science",
        renderItem: function renderItem(item) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: loading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (course_form_module_default()).dropdown_item,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (course_form_module_default()).dropdown_head,
                children: item === null || item === void 0 ? void 0 : item.specializationName
              })
            })
          });
        },
        onChange: handleChange,
        onSelect: function onSelect(item) {
          setSelectedValue(item);
          setInput(item);
        },
        customClasses: {
          root: (course_form_module_default()).root
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "border-[10px] border-white rounded-[10px]",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(select_level, {
        levelValue: levelValue,
        setLevelValue: setLevelValue
      })
    }), levelValue && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "border-[10px] border-white rounded-[10px]",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(select_country, {
        countryValue: countryValue,
        setCountryValue: setCountryValue
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex justify-end",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        onClick: pushToSearchPage,
        disabled: typeof input !== "object",
        className: "btn btn-bg btn-primary ".concat(typeof input !== "object" ? "bg-[#7a7a7a] pointer-events-none	" : ""),
        children: "Find Courses"
      })
    })]
  });
};

/* harmony default export */ var course_form = (AdvancedSearchCourseForm);
;// CONCATENATED MODULE: ./_modules/study/common/advance_search/advanced_search_dropdown/index.jsx


var AdvancedSearch = function AdvancedSearch() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "max-w-[700px] w-full mx-auto flex justify-center p-5 md:p-10 mb-10 border rounded-lg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "w-full",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(course_form, {})
    })
  });
};
/* harmony default export */ var advanced_search_dropdown = (AdvancedSearch);
// EXTERNAL MODULE: ./_recoil/_state/search_popup.js
var search_popup = __webpack_require__(2511);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./_unisearch/theme/layout/headers/header_search/header_search.module.scss
var header_search_module = __webpack_require__(15100);
var header_search_module_default = /*#__PURE__*/__webpack_require__.n(header_search_module);
// EXTERNAL MODULE: ./node_modules/@formkit/auto-animate/react/index.mjs + 1 modules
var auto_animate_react = __webpack_require__(79250);
;// CONCATENATED MODULE: ./_unisearch/theme/layout/headers/header_search/index.jsx



function header_search_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function header_search_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? header_search_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : header_search_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var Modal = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 420).then(__webpack_require__.bind(__webpack_require__, 80420));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(80420)];
    }
  }
});



var CourseSearch = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(260), __webpack_require__.e(5996), __webpack_require__.e(14)]).then(__webpack_require__.bind(__webpack_require__, 22998));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(22998)];
    }
  }
});
var CommonSearch = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 3420).then(__webpack_require__.bind(__webpack_require__, 43420));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(43420)];
    }
  }
});

var HeaderSearch = function HeaderSearch(props) {
  var _useAutoAnimate = (0,auto_animate_react/* useAutoAnimate */.u)(),
      _useAutoAnimate2 = (0,slicedToArray/* default */.Z)(_useAutoAnimate, 1),
      animationParent = _useAutoAnimate2[0];

  var _useRecoilState = (0,recoil/* useRecoilState */.FV)(search_popup/* searchPopupState */.F),
      _useRecoilState2 = (0,slicedToArray/* default */.Z)(_useRecoilState, 2),
      _ = _useRecoilState2[0],
      setPopupState = _useRecoilState2[1];

  var _useState = (0,react.useState)(1),
      tab = _useState[0],
      setTab = _useState[1];

  var _useState2 = (0,react.useState)(false),
      open = _useState2[0],
      setOpen = _useState2[1];

  var handleOpen = function handleOpen() {
    setOpen(true);
    setPopupState({
      open: true,
      enablePopup: false
    });
  };

  var handleClose = function handleClose() {
    setOpen(false);
    setPopupState(function (prev) {
      return header_search_objectSpread(header_search_objectSpread({}, prev), {}, {
        open: false
      });
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      onClick: handleOpen,
      className: "".concat((header_search_module_default()).header_search_wrapper, " ").concat(props.className),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (header_search_module_default()).search_placeholder,
        children: props.placeholder
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FiSearch */.jRj, {
        className: (header_search_module_default()).search_icon
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Modal, {
      "aria-labelledby": "transition-modal-title",
      "aria-describedby": "transition-modal-description",
      open: open,
      onClose: handleClose,
      sx: {
        zIndex: "2000"
      },
      id: "search_modal",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (header_search_module_default()).search_popup,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: handleClose,
          className: (header_search_module_default()).cross_icon,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FiX */.q5L, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "container",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (header_search_module_default()).content_wrapper,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (header_search_module_default()).tab_wrapper,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                className: "btn ".concat(tab === 1 ? "btn-secondary ".concat((header_search_module_default()).hover_change) : "btn-outline", " btn-bg"),
                onClick: function onClick() {
                  return setTab(1);
                },
                children: "Course Search"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                className: "btn ".concat(tab === 2 ? "btn-secondary ".concat((header_search_module_default()).hover_change) : "btn-outline", "  btn-bg"),
                onClick: function onClick() {
                  return setTab(2);
                },
                children: "Advanced Course Search"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                className: "btn ".concat(tab === 3 ? "btn-secondary ".concat((header_search_module_default()).hover_change) : "btn-outline", "  btn-bg"),
                onClick: function onClick() {
                  return setTab(3);
                },
                children: "Common Search"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (header_search_module_default()).search_input_wrapper,
              ref: animationParent,
              children: [tab === 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "relative",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(CourseSearch, {
                  showBig: props.showBig,
                  popupHandler: handleClose
                })
              }), tab === 2 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(advanced_search_dropdown, {
                  popupHandler: handleClose
                })
              }), tab === 3 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (header_search_module_default()).conent_search_wrapper,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(CommonSearch, {
                  popupHandler: handleClose
                })
              })]
            })]
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var header_search = (HeaderSearch);

/***/ }),

/***/ 81496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ku": function() { return /* reexport */ LayoutMain; },
  "vV": function() { return /* reexport */ LayoutStudent; },
  "Zg": function() { return /* reexport */ LayoutUniversityPage; }
});

// UNUSED EXPORTS: HeaderCampaign, HeaderMobileOne, HeaderOne, HeaderUniversity

// EXTERNAL MODULE: ./_unisearch/theme/layout/headers/header_one/index.jsx
var header_one = __webpack_require__(6195);
// EXTERNAL MODULE: ./_unisearch/theme/layout/headers/header_mobile/index.jsx + 1 modules
var header_mobile = __webpack_require__(78599);
// EXTERNAL MODULE: ./_unisearch/theme/layout/headers/header_campaign/index.jsx
var header_campaign = __webpack_require__(26204);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./_unisearch/theme/layout/headers/header_university/header_university.module.scss
var header_university_module = __webpack_require__(7867);
var header_university_module_default = /*#__PURE__*/__webpack_require__.n(header_university_module);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_unisearch/theme/layout/headers/header_university/index.jsx






var HeaderUniversity = function HeaderUniversity() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("nav", {
    className: (header_university_module_default()).header,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        legacyBehavior: true,
        href: "/university",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          className: (header_university_module_default()).logo,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: (0,helpers/* getAssets */.Vh)("assets/logo-beta.webp"),
            alt: "UniSearch Logo",
            blurDataURL: (0,helpers/* getAssets */.Vh)("assets/logo-beta.webp"),
            placeholder: "blur",
            width: 186,
            height: 30
          })
        })
      })
    })
  });
};
/* harmony default export */ var header_university = ((/* unused pure expression or super */ null && (HeaderUniversity)));
;// CONCATENATED MODULE: ./_unisearch/theme/layout/headers/index.js




// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./_recoil/_state/index.js + 9 modules
var _state = __webpack_require__(89093);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./_redux/apiSlice.js + 2 modules
var apiSlice = __webpack_require__(57188);
;// CONCATENATED MODULE: ./_redux/misc/miscApi/navApi.js

var navApi = apiSlice/* apiSlice.injectEndpoints */.g.injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      getNav: build.query({
        query: function query() {
          return "/public/navbar";
        }
      })
    };
  }
});
var useGetNavQuery = navApi.useGetNavQuery;

// EXTERNAL MODULE: ./_unisearch/common/skeleton/index.jsx
var skeleton = __webpack_require__(21197);
// EXTERNAL MODULE: ./_unisearch/theme/layout/headers/header_one/loader/loader.module.scss
var loader_module = __webpack_require__(76148);
var loader_module_default = /*#__PURE__*/__webpack_require__.n(loader_module);
;// CONCATENATED MODULE: ./_unisearch/theme/layout/headers/header_one/loader/index.jsx




var HeaderMainLoader = function HeaderMainLoader() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "container-extend",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (loader_module_default()).grid,
      children: new Array(3).fill(1).map(function (_, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
          className: (loader_module_default()).sk1
        }, index);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (loader_module_default()).grid2,
      children: new Array(3).fill(1).map(function (_, i) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
          className: (loader_module_default()).grid2_skeletor
        }, i);
      })
    })]
  });
};
/* harmony default export */ var loader = (HeaderMainLoader);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./_recoil/_state/search_popup.js
var search_popup = __webpack_require__(2511);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(41248);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
// EXTERNAL MODULE: ./_hooks/useWindowDimensions.js
var _hooks_useWindowDimensions = __webpack_require__(14418);
;// CONCATENATED MODULE: ./_unisearch/common/popup/event/index.jsx












var EventPopup = function EventPopup(_ref) {
  var openEventPopup = _ref.openEventPopup,
      closeEventPopup = _ref.closeEventPopup;

  var _useSelector = useSelector(function (state) {
    return state.homePopup;
  }),
      homePopupIsOpen = _useSelector.isOpen;

  var _useWindowDimensions = useWindowDimensions(),
      width = _useWindowDimensions.width;

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Dialog, {
      open: openEventPopup,
      onClose: function onClose() {
        return closeEventPopup(false);
      },
      maxWidth: "md",
      fullWidth: true,
      classes: {
        paper: styles.modal_width
      },
      children: [/*#__PURE__*/_jsx(FiX, {
        onClick: function onClick() {
          return closeEventPopup(false);
        },
        className: styles.close
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.wrapper,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.left,
          children: width > 720 ? /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsx(Image, {
              src: "/assets/images/events/images/usa-admission-day-popup.webp",
              alt: "Attend UniSearch\u2019s USA Admission Day",
              title: "Attend UniSearch\u2019s USA Admission Day",
              width: 270,
              height: 474,
              className: styles.image
            })
          }) : /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsx(Image, {
              src: "/assets/images/events/images/usa-admission-day-popup-mobile.webp",
              alt: "Attend UniSearch\u2019s USA Admission Day",
              title: "Attend UniSearch\u2019s USA Admission Day",
              width: 720,
              height: 162,
              className: styles.image
            })
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.right,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.subtitle,
            children: "Dreaming of Studying in the USA?"
          }), /*#__PURE__*/_jsx("h2", {
            className: styles.title,
            children: "Attend UniSearch\u2019s USA Admission Day"
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.info,
            children: [/*#__PURE__*/_jsxs("div", {
              className: styles.info_item,
              children: [/*#__PURE__*/_jsx(Image, {
                src: "/assets/images/events/icons/calender.webp",
                alt: "Data 4th March, 2023",
                width: 16,
                height: 16
              }), /*#__PURE__*/_jsx("span", {
                children: "4th March, 2023"
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.info_item,
              children: [/*#__PURE__*/_jsx(Image, {
                src: "/assets/images/events/icons/watch.webp",
                alt: "time 2pm - 5pm",
                width: 16,
                height: 16
              }), /*#__PURE__*/_jsx("span", {
                children: "2 pm - 5 pm"
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.info_item,
              children: [/*#__PURE__*/_jsx(Image, {
                src: "/assets/images/events/icons/map-pin.webp",
                alt: "Place Bangalore, India",
                width: 16,
                height: 16
              }), /*#__PURE__*/_jsx("span", {
                children: "Bangalore, India"
              })]
            })]
          }), /*#__PURE__*/_jsxs("ul", {
            className: styles.heighlights,
            children: [/*#__PURE__*/_jsxs("li", {
              children: [/*#__PURE__*/_jsx(ReactSVG, {
                src: "/assets/images/events/icons/checked.svg"
              }), /*#__PURE__*/_jsx("span", {
                children: "Meet US university representatives"
              })]
            }), /*#__PURE__*/_jsxs("li", {
              children: [/*#__PURE__*/_jsx(ReactSVG, {
                src: "/assets/images/events/icons/checked.svg"
              }), /*#__PURE__*/_jsx("span", {
                children: "Get on-spot profile evaluation"
              })]
            }), /*#__PURE__*/_jsxs("li", {
              children: [/*#__PURE__*/_jsx(ReactSVG, {
                src: "/assets/images/events/icons/checked.svg"
              }), /*#__PURE__*/_jsx("span", {
                children: "Access personalized guidance"
              })]
            }), /*#__PURE__*/_jsxs("li", {
              children: [/*#__PURE__*/_jsx(ReactSVG, {
                src: "/assets/images/events/icons/checked.svg"
              }), /*#__PURE__*/_jsxs("span", {
                children: ["Explore options for the next intake ", /*#__PURE__*/_jsx("br", {}), "And more!"]
              })]
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: styles.btn_wrapper,
            children: /*#__PURE__*/_jsx(Link, {
              href: "/events/usa-admission-day",
              className: "btn btn-secondary btn-bg",
              children: "Sign Up Today"
            })
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var popup_event = ((/* unused pure expression or super */ null && (EventPopup)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./_modules/lead/components/index.js + 6 modules
var components = __webpack_require__(56205);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Modal/Modal.js + 2 modules
var Modal = __webpack_require__(15825);
// EXTERNAL MODULE: ./_unisearch/helpers/api/index.js
var api = __webpack_require__(85014);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./_unisearch/common/popup/lead/lead.module.scss
var lead_module = __webpack_require__(48947);
var lead_module_default = /*#__PURE__*/__webpack_require__.n(lead_module);
;// CONCATENATED MODULE: ./_unisearch/common/popup/lead/index.jsx













var LeadPopupNew = function LeadPopupNew(_ref) {
  var openLeadPopup = _ref.openLeadPopup,
      setOpenLeadPopup = _ref.setOpenLeadPopup;

  var _useState = (0,react.useState)(),
      pageData = _useState[0],
      setPageData = _useState[1];

  var fetchData = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var res;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return api/* default.get */.Z.get("public/lead-contact-form/pages/popup");

            case 2:
              res = _context.sent;

              if (res && !res.error) {
                setPageData(res.data);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchData() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    fetchData();
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
      open: openLeadPopup,
      onClose: function onClose() {
        return setOpenLeadPopup(false);
      },
      "aria-labelledby": "transition-modal-title",
      "aria-describedby": "transition-modal-description",
      id: "popup_modal",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "modal md",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: "cross_icon",
          onClick: function onClick() {
            return setOpenLeadPopup(false);
          },
          style: {
            transform: "unset",
            top: "15px",
            right: "8px"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FiX */.q5L, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (lead_module_default()).popup_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (lead_module_default()).popup_left,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
              className: (lead_module_default()).heading,
              children: ["Want to study abroad? Sign up with", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "color-orange",
                children: "UniSearch!"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (lead_module_default()).sub_heading,
              children: "Jumpstart your study abroad dreams with UniSearch"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              className: (lead_module_default()).list_wrapper,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: "/assets/icons/popup_check.png",
                  width: 12,
                  height: 12
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "Free counselling for major destinations"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: "/assets/icons/popup_check.png",
                  width: 12,
                  height: 12
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "Thorough application and visa guidance"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: "/assets/icons/popup_check.png",
                  width: 12,
                  height: 12
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "Discover scholarships and funding"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: "/assets/icons/popup_check.png",
                  width: 12,
                  height: 12
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "Complete IELTS and PTE Academic support"
                })]
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (lead_module_default()).popup_right,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (lead_module_default()).right_heading,
              children: "Register today to discover, connect with, and apply to your ideal university abroad!"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (lead_module_default()).popup_form_wrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* LeadForm */.pn, {
                showTitle: false,
                showSubTitle: false,
                pageData: pageData,
                buttonTitle: "Submit",
                btnSizeFull: false,
                handleClose: function handleClose() {
                  return setOpenLeadPopup(false);
                },
                pageSlug: pageData === null || pageData === void 0 ? void 0 : pageData.slug
              })
            })]
          })]
        })]
      })
    })
  });
};

/* harmony default export */ var lead = (LeadPopupNew);
;// CONCATENATED MODULE: ./_unisearch/common/popup/event_canada/index.jsx












var EventPopupCanada = function EventPopupCanada(_ref) {
  var openEventPopup = _ref.openEventPopup,
      closeEventPopup = _ref.closeEventPopup;

  var _useSelector = useSelector(function (state) {
    return state.homePopup;
  }),
      homePopupIsOpen = _useSelector.isOpen;

  var _useWindowDimensions = useWindowDimensions(),
      width = _useWindowDimensions.width;

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Dialog, {
      open: openEventPopup,
      onClose: function onClose() {
        return closeEventPopup(false);
      },
      maxWidth: "md",
      fullWidth: true,
      classes: {
        paper: styles.modal_width
      },
      children: [/*#__PURE__*/_jsx(FiX, {
        onClick: function onClick() {
          return closeEventPopup(false);
        },
        className: styles.close
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.wrapper,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.left,
          children: width > 720 ? /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsx(Image, {
              src: "/assets/images/events/images/canada-admission-day-popup.webp",
              alt: "Attend UniSearch\u2019s Canada Admission Day",
              title: "Attend UniSearch\u2019s Canada Admission Day",
              width: 270,
              height: 474,
              className: styles.image
            })
          }) : /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsx(Image, {
              src: "/assets/images/events/images/canada-admission-day-popup-mobile.webp",
              alt: "Attend UniSearch\u2019s Canada Admission Day",
              title: "Attend UniSearch\u2019s Canada Admission Day",
              width: 720,
              height: 162,
              className: styles.image
            })
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.right,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.subtitle,
            children: "Dreaming of Studying in Canada?"
          }), /*#__PURE__*/_jsx("h2", {
            className: styles.title,
            children: "Attend UniSearch\u2019s Canada Admission Day"
          }), /*#__PURE__*/_jsx("div", {
            className: styles.event_tag,
            children: "VIRTUAL EVENT"
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.info,
            children: [/*#__PURE__*/_jsxs("div", {
              className: styles.info_item,
              children: [/*#__PURE__*/_jsx(Image, {
                src: "/assets/images/events/icons/calender.webp",
                alt: "Data 4th March, 2023",
                width: 16,
                height: 16
              }), /*#__PURE__*/_jsx("span", {
                children: "25th March, 2023"
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.info_item,
              children: [/*#__PURE__*/_jsx(Image, {
                src: "/assets/images/events/icons/watch.webp",
                alt: "time 2pm - 5pm",
                width: 16,
                height: 16
              }), /*#__PURE__*/_jsx("span", {
                children: "2 pm - 5 pm"
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.info_item,
              children: [/*#__PURE__*/_jsx(Image, {
                src: "/assets/images/events/icons/map-pin.webp",
                alt: "Place Chandigarh, India",
                width: 16,
                height: 16
              }), /*#__PURE__*/_jsx("span", {
                children: "Chandigarh, India"
              })]
            })]
          }), /*#__PURE__*/_jsxs("ul", {
            className: styles.heighlights,
            children: [/*#__PURE__*/_jsxs("li", {
              children: [/*#__PURE__*/_jsx(ReactSVG, {
                src: "/assets/images/events/icons/checked.svg"
              }), /*#__PURE__*/_jsx("span", {
                children: "Meet Canada university representatives"
              })]
            }), /*#__PURE__*/_jsxs("li", {
              children: [/*#__PURE__*/_jsx(ReactSVG, {
                src: "/assets/images/events/icons/checked.svg"
              }), /*#__PURE__*/_jsx("span", {
                children: "Get on-spot profile evaluation"
              })]
            }), /*#__PURE__*/_jsxs("li", {
              children: [/*#__PURE__*/_jsx(ReactSVG, {
                src: "/assets/images/events/icons/checked.svg"
              }), /*#__PURE__*/_jsx("span", {
                children: "Access personalized guidance"
              })]
            }), /*#__PURE__*/_jsxs("li", {
              children: [/*#__PURE__*/_jsx(ReactSVG, {
                src: "/assets/images/events/icons/checked.svg"
              }), /*#__PURE__*/_jsxs("span", {
                children: ["Explore options for the next intake ", /*#__PURE__*/_jsx("br", {}), "And more!"]
              })]
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: styles.btn_wrapper,
            children: /*#__PURE__*/_jsx(Link, {
              href: "/events/canada-admissions-day",
              className: "btn btn-secondary btn-bg",
              children: "Sign Up Today"
            })
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var event_canada = ((/* unused pure expression or super */ null && (EventPopupCanada)));
;// CONCATENATED MODULE: ./_unisearch/common/popup/index.jsx










var Popup = function Popup(_ref) {
  var _ref$isLeadPopup = _ref.isLeadPopup,
      isLeadPopup = _ref$isLeadPopup === void 0 ? false : _ref$isLeadPopup;

  var _useRecoilValue = (0,recoil/* useRecoilValue */.sJ)(search_popup/* searchPopupState */.F),
      open = _useRecoilValue.open,
      isOpenHomePagePopup = _useRecoilValue.isOpenHomePagePopup;

  var router = (0,next_router.useRouter)();
  var asPath = router.asPath;

  var _useState = (0,react.useState)(false),
      openEventPopup = _useState[0],
      setOpenEventPopup = _useState[1];

  var _useState2 = (0,react.useState)(false),
      openLeadPopup = _useState2[0],
      setOpenLeadPopup = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isMounted = _useState3[0],
      setMounted = _useState3[1];

  (0,react.useEffect)(function () {
    setTimeout(function () {
      setOpenLeadPopup(true);
    }, 6000);
  }, [asPath]); //**
  // Old code start
  //
  // useEffect(() => {
  //   setTimeout(() => {
  //     setOpenEventPopup(true);
  //   }, 2000);
  // }, [asPath]);
  // useEffect(() => {
  //   if (isMounted == false) return;
  //   if (openEventPopup == false) {
  //     setTimeout(() => {
  //       setOpenLeadPopup(true);
  //     }, 2000);
  //   }
  // }, [openEventPopup]);
  // const closeEventPopup = () => {
  //   setOpenEventPopup(false);
  //   setMounted(true);
  // };
  // const closeLeadPopup = () => {
  //   setOpenLeadPopup(false);
  //   setMounted(false);
  // };
  // old code end

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: open == false && isOpenHomePagePopup == false ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: isLeadPopup && /*#__PURE__*/(0,jsx_runtime.jsx)(lead, {
        openLeadPopup: openLeadPopup,
        setOpenLeadPopup: setOpenLeadPopup
      })
    }) : null
  });
};

/* harmony default export */ var popup = (Popup);
;// CONCATENATED MODULE: ./_unisearch/common/cookie_popup/index.jsx






var CookiePopup = function CookiePopup(_ref) {
  var handleCookiePopup = _ref.handleCookiePopup;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.wrapper,
      children: [/*#__PURE__*/_jsx("button", {
        className: styles.close,
        onClick: function onClick() {
          return handleCookiePopup();
        },
        children: /*#__PURE__*/_jsx(FiX, {})
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.text,
        children: [/*#__PURE__*/_jsx("span", {
          children: "This site uses cookies. By continuing to use this website, you agree to their use. For details, please check our."
        }), " ", /*#__PURE__*/_jsx(Link, {
          href: "/terms-and-conditions",
          className: styles.link,
          children: "Privacy Policy"
        })]
      }), /*#__PURE__*/_jsx("button", {
        onClick: function onClick() {
          return handleCookiePopup();
        },
        className: "btn btn-secondary btn-sm",
        children: "I Accept"
      })]
    })
  });
};
/* harmony default export */ var cookie_popup = ((/* unused pure expression or super */ null && (CookiePopup)));
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
;// CONCATENATED MODULE: ./_unisearch/theme/layout/main.js
/* eslint-disable @next/next/next-script-for-ga */

/* eslint-disable @next/next/no-img-element */















var HeaderOne = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 6195));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(loader, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(6195)];
    }
  }
});
var HeaderCampaign = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 26204));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(26204)];
    }
  }
});
var FixedPopup = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 46865));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(46865)];
    }
  }
});
var FooterOne = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 71634));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(71634)];
    }
  }
});
var LayoutMain = function LayoutMain(_ref) {
  var _ref$footer_with_eval = _ref.footer_with_evaluation,
      footer_with_evaluation = _ref$footer_with_eval === void 0 ? false : _ref$footer_with_eval,
      children = _ref.children,
      title = _ref.title,
      metaTitle = _ref.metaTitle,
      metaKeywords = _ref.metaKeywords,
      metaDescription = _ref.metaDescription,
      metaUrl = _ref.metaUrl,
      metaImage = _ref.metaImage,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? "headerOne" : _ref$header,
      _ref$fixedPopup = _ref.fixedPopup,
      fixedPopup = _ref$fixedPopup === void 0 ? true : _ref$fixedPopup,
      _ref$footer = _ref.footer,
      footer = _ref$footer === void 0 ? true : _ref$footer,
      JsonLd = _ref.JsonLd,
      _ref$isHeaderSticky = _ref.isHeaderSticky,
      isHeaderSticky = _ref$isHeaderSticky === void 0 ? false : _ref$isHeaderSticky,
      _ref$isLeadPopup = _ref.isLeadPopup,
      isLeadPopup = _ref$isLeadPopup === void 0 ? false : _ref$isLeadPopup,
      _ref$isCookiePopup = _ref.isCookiePopup,
      isCookiePopup = _ref$isCookiePopup === void 0 ? true : _ref$isCookiePopup,
      _ref$ogType = _ref.ogType,
      ogType = _ref$ogType === void 0 ? "website" : _ref$ogType;
  var userDatas = (0,recoil/* useRecoilValue */.sJ)(_state/* authAtom */.L4);

  var _useState = (0,react.useState)(),
      userData = _useState[0],
      setUserData = _useState[1];

  var _useGetNavQuery = useGetNavQuery(),
      data = _useGetNavQuery.data,
      isLoading = _useGetNavQuery.isLoading;

  var menuList = data === null || data === void 0 ? void 0 : data.data;
  var cookie_policy = js_cookie/* default.get */.Z.get("cookie_policy");

  var _useState2 = (0,react.useState)(false),
      cookieView = _useState2[0],
      setCookiePolicy = _useState2[1];

  var formatedTitle = title ? "".concat(title, " | UniSearch") : "UniSearch: The Ultimate Study Abroad Toolkit for Every Stage | UniSearch";
  var formatedMetaTitle = metaTitle ? "".concat(metaTitle, " | UniSearch") : formatedTitle;
  var formatedMetaDescriptionRaw = metaDescription ? "".concat(metaDescription) : formatedTitle.replace("| UniSearch", "");
  var formatedMetaDescription = formatedMetaDescriptionRaw === null || formatedMetaDescriptionRaw === void 0 ? void 0 : formatedMetaDescriptionRaw.slice(0, 150);
  (0,react.useEffect)(function () {
    if (userDatas) {
      setUserData(userDatas);
    }

    if (cookie_policy && cookie_policy == "Yes") {
      setCookiePolicy(false);
    } else {
      setCookiePolicy(true);
    }
  }, [userDatas]);

  var handleCookiePopup = function handleCookiePopup() {
    js_cookie/* default.set */.Z.set("cookie_policy", "Yes");
    setCookiePolicy(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        charSet: "UTF-8"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        httpEquiv: "X-UA-Compatible",
        content: "IE=edge"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "theme-color",
        content: "#f47f20"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: formatedTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "manifest",
        href: "/manifest.webmanifest"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "icon",
        type: "image/x-icon",
        href: "/favicon.ico"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "p:domain_verify",
        content: "c7f4dc207b5a2b8446692325a0dfb112"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "facebook-domain-verification",
        content: "025mfzyubxk5w3ws6cj9ra838kz8sz"
      }),  true && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "google-site-verification",
        content: "RFoBnS3QiQEsqCjHmul_v48eD6tcRodn-Sk4enU8UI8"
      }),  false && /*#__PURE__*/0, metaUrl && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: metaUrl
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "title",
        content: formatedMetaTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "keywords",
        content: metaKeywords || "unisearch, study abroad, exam, document, courses"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: formatedMetaDescription
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: formatedMetaTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: formatedMetaDescription
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:type",
        content: ogType
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:site_name",
        content: "UniSearch"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: metaUrl !== null && metaUrl !== void 0 ? metaUrl : "https://myunisearch.com/"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: metaImage !== null && metaImage !== void 0 ? metaImage : (0,helpers/* getAssets */.Vh)("assets/unisearch-meta-logo.png")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-icon",
        href: metaImage !== null && metaImage !== void 0 ? metaImage : (0,helpers/* getAssets */.Vh)("assets/unisearch-meta-logo.png")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:title",
        content: formatedMetaTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:description",
        content: formatedMetaDescription
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:image",
        content: metaImage || (0,helpers/* getAssets */.Vh)("assets/unisearch-meta-logo.png")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:card",
        content: "summary_large_image"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "referrer",
        content: "no-referrer"
      }), JsonLd && /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: JsonLd()
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      defer: true,
      "data-domain":  true ? "myunisearch.com" : 0,
      src: "https://analytics.myunisearch.com/js/plausible.js",
      strategy: "lazyOnload"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      async: true,
      crossorigin: "anonymous",
      src: "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972",
      strategy: "lazyOnload"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      defer: true,
      src: "https://www.googletagmanager.com/gtag/js?id=G-CBM37S40N3",
      strategy: "lazyOnload"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      defer: true,
      dangerouslySetInnerHTML: {
        __html: "\n              window.dataLayer = window.dataLayer || [];\n              function gtag(){dataLayer.push(arguments);}\n              gtag('js', new Date());\n              gtag('config', 'G-CBM37S40N3', { page_path: window.location.pathname });\n            "
      },
      strategy: "lazyOnload"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      defer: true,
      dangerouslySetInnerHTML: {
        __html: "\n            !function(f,b,e,v,n,t,s)\n            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n            n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n            n.queue=[];t=b.createElement(e);t.async=!0;\n            t.src=v;s=b.getElementsByTagName(e)[0];\n            s.parentNode.insertBefore(t,s)}(window, document,'script',\n            'https://connect.facebook.net/en_US/fbevents.js');\n            fbq('init', '466355328286746');\n            fbq('track', 'PageView');\n            "
      },
      strategy: "lazyOnload"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("noscript", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        height: "0",
        width: "0",
        style: {
          display: "none"
        },
        src: "https://www.facebook.com/tr?id=466355328286746&ev=PageView&noscript=1",
        alt: ""
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()) // defer
    , {
      src: "https://unpkg.com/typebot-js@2.2" // strategy="lazyOnload"

    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      defer: true,
      dangerouslySetInnerHTML: {
        __html: " \n        if (typeof Typebot === 'object') {\n          var typebotCommands = Typebot.initBubble({\n            url: \"https://unibot-view.myunisearch.com/unisearch-query-chat-u6kgek5\",\n            proactiveMessage: {\n              avatarUrl: \"https://img.icons8.com/office/512/robot-2.png\",\n              textContent: \"I have a question for you!\",\n              delay: 0,\n            },\n            button: { color: \"#d48311\" },\n          });\n        }\n          "
      },
      strategy: "lazyOnload"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      defer: true,
      src: "//d2wy8f7a9ursnm.cloudfront.net/v7/bugsnag.min.js"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      strategy: "lazyOnload",
      children: "\n        if (typeof Bugsnag === 'object') {\n        Bugsnag.start({ apiKey: 'f816a469163b124a51e8851b652ecba5' })}"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [header === "headerOne" && /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderOne, {
        isHeaderSticky: isHeaderSticky,
        menuData: {
          menuList: menuList,
          isLoading: isLoading
        },
        userData: userData
      }), header === "headerCampaign" && /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderCampaign, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("main", {
      children: children
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(popup, {
      isLeadPopup: isLeadPopup
    }), fixedPopup && /*#__PURE__*/(0,jsx_runtime.jsx)(FixedPopup, {}), footer && /*#__PURE__*/(0,jsx_runtime.jsx)(FooterOne, {
      userData: userData,
      footer_with_evaluation: footer_with_evaluation
    })]
  });
};
/* harmony default export */ var main = ((/* unused pure expression or super */ null && (LayoutMain)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./_unisearch/common/widgets/loader/loader.module.scss
var loader_loader_module = __webpack_require__(9463);
var loader_loader_module_default = /*#__PURE__*/__webpack_require__.n(loader_loader_module);
;// CONCATENATED MODULE: ./_unisearch/common/widgets/loader/full_page_loader.js



var FullPageLoader = function FullPageLoader() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (loader_loader_module_default()).loading,
    children: "Loading\u2026"
  });
};
/* harmony default export */ var full_page_loader = ((/* unused pure expression or super */ null && (FullPageLoader)));
;// CONCATENATED MODULE: ./_unisearch/common/widgets/loader/index.js

// EXTERNAL MODULE: ./_unisearch/auth/index.js + 29 modules
var auth = __webpack_require__(22267);
// EXTERNAL MODULE: ./_unisearch/theme/layout/headers/components/account_menu/index.jsx
var account_menu = __webpack_require__(98781);
// EXTERNAL MODULE: ./_unisearch/theme/layout/headers/header_search/index.jsx + 5 modules
var header_search = __webpack_require__(14890);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Badge/Badge.js + 5 modules
var Badge = __webpack_require__(60082);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Menu/Menu.js + 4 modules
var Menu = __webpack_require__(32819);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Alert/Alert.js + 6 modules
var Alert_Alert = __webpack_require__(82741);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Snackbar/Snackbar.js + 4 modules
var Snackbar = __webpack_require__(69243);
// EXTERNAL MODULE: ./node_modules/pusher-js/dist/web/pusher.js
var web_pusher = __webpack_require__(86606);
var pusher_default = /*#__PURE__*/__webpack_require__.n(web_pusher);
// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var io_index_esm = __webpack_require__(51649);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(64213);
// EXTERNAL MODULE: ./_unisearch/theme/layout/student_admin/notification/notification.module.scss
var notification_module = __webpack_require__(17681);
var notification_module_default = /*#__PURE__*/__webpack_require__.n(notification_module);
;// CONCATENATED MODULE: ./_unisearch/theme/layout/student_admin/notification/index.jsx





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react-hooks/exhaustive-deps */



















var Alert = /*#__PURE__*/react.forwardRef(function Alert(props, ref) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Alert_Alert/* default */.Z, _objectSpread({
    elevation: 6,
    ref: ref,
    variant: "filled"
  }, props));
});
var StudentNotificationComponent = function StudentNotificationComponent(_ref) {
  var _list$sort;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? false : _ref$type;

  var _useState = (0,react.useState)(false),
      notification = _useState[0],
      setNotification = _useState[1];

  var _useState2 = (0,react.useState)(""),
      notificationMsg = _useState2[0],
      setNotificationMsg = _useState2[1];

  var profileInfo = (0,recoil/* useRecoilValue */.sJ)(_state/* authAtom */.L4);
  var router = (0,next_router.useRouter)();

  var _useState3 = (0,react.useState)([]),
      list = _useState3[0],
      setList = _useState3[1];

  var _useState4 = (0,react.useState)(0),
      otherTotal = _useState4[0],
      setOtherTotal = _useState4[1];

  var _useState5 = (0,react.useState)(0),
      ConversationTotal = _useState5[0],
      setConversationTotal = _useState5[1];

  var _useState6 = (0,react.useState)(null),
      anchorEl = _useState6[0],
      setAnchorEl = _useState6[1];

  var open = Boolean(anchorEl);

  var _useState7 = (0,react.useState)(true),
      hasMore = _useState7[0],
      setHasMore = _useState7[1];

  var _useState8 = (0,react.useState)(1),
      page = _useState8[0],
      setPage = _useState8[1];

  var handleCloseNotification = function handleCloseNotification(event, reason) {
    if (reason === "clickaway") {
      return;
    }

    setNotification(false);
  }; //handle open


  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
    document.body.classList.add("popOpen");
  }; //handle close


  var handleClose = function handleClose() {
    setAnchorEl(null);
    document.body.classList.remove("popOpen");
  };

  var getNotification = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return api/* default.post */.Z.post("/student/filter-notification", {
                filter: {},
                sortOrder: "ASC",
                sortField: "id",
                pageNumber: page,
                pageSize: 10
              }).then(function (res) {
                if (!res.error && res !== null && res !== void 0 && res.data) {
                  var _res$data;

                  var results = res.data.results;
                  setList(function (prev) {
                    return [].concat((0,toConsumableArray/* default */.Z)(prev), (0,toConsumableArray/* default */.Z)(results));
                  });
                  setOtherTotal((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.total);
                } else {
                  setHasMore(false);
                }
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getNotification() {
      return _ref2.apply(this, arguments);
    };
  }(); // read all


  var readAllNotification = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(type === "conversation")) {
                _context4.next = 5;
                break;
              }

              _context4.next = 3;
              return api/* default.get */.Z.get("/student/student-notification/mark-all-read/email").then( /*#__PURE__*/function () {
                var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(res) {
                  return regenerator_default().wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (res.error) {
                            _context2.next = 7;
                            break;
                          }

                          setPage(1);
                          setList([]);
                          _context2.next = 5;
                          return getNotification();

                        case 5:
                          setConversationTotal(0);
                          setOtherTotal(0);

                        case 7:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x) {
                  return _ref4.apply(this, arguments);
                };
              }());

            case 3:
              _context4.next = 7;
              break;

            case 5:
              _context4.next = 7;
              return api/* default.get */.Z.get("/student/student-notification/mark-all-read/all").then( /*#__PURE__*/function () {
                var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(res) {
                  return regenerator_default().wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (res.error) {
                            _context3.next = 7;
                            break;
                          }

                          setPage(1);
                          setList([]);
                          _context3.next = 5;
                          return getNotification();

                        case 5:
                          setConversationTotal(0);
                          setOtherTotal(0);

                        case 7:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x2) {
                  return _ref5.apply(this, arguments);
                };
              }());

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function readAllNotification() {
      return _ref3.apply(this, arguments);
    };
  }(); // read one


  var readSingle = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(id, item) {
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return api/* default.get */.Z.get("/student/student-notification/".concat(id)).then(function (res) {
                if (!res.error) {
                  setList([]);
                  getNotification();

                  if ((item === null || item === void 0 ? void 0 : item.conversationId) !== null) {
                    handleClose();
                    router.push("/app/student/conversation/inbox/".concat(item === null || item === void 0 ? void 0 : item.conversationId));
                  } else if ((item === null || item === void 0 ? void 0 : item.type) === "profile evolution") {
                    handleClose();
                    router.push("/app/student/report");
                  } else {
                    router.push("".concat(item.link));
                  }
                }
              });

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function readSingle(_x3, _x4) {
      return _ref6.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    getNotification();
    var pusher = new (pusher_default())("".concat("0a127dde85ce007475ee"), {
      cluster: "ap2"
    });
    var channel = pusher.subscribe("".concat("unisearch-production"));
    channel.bind("student".concat(profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.id), function (data) {
      var _data$message;

      setList([]);
      getNotification();
      setNotification(true);
      setNotificationMsg(data === null || data === void 0 ? void 0 : (_data$message = data.message) === null || _data$message === void 0 ? void 0 : _data$message.message);
    });
  }, [page]);

  var getMore = function getMore() {
    setPage(page + 1);
  };

  var getNotificationImage = function getNotificationImage(item) {
    if (item == "favorite_university" || item == "favorite_course" || item == "favorite_courses") {
      return "assets/icons/Favorite.svg";
    } else if (item == "compare_university" || item == "compare_course" || item == "compare_courses") {
      return "assets/icons/Compare.svg";
    } else if (item == "article_bookmark") {
      return "assets/icons/Bookmark.svg";
    } else if (item == "review") {
      return "assets/icons/Review.svg";
    } else if (item == "prospectus") {
      return "assets/icons/Prospectus.svg";
    } else if (item == "course_guide") {
      return "assets/icons/Course.svg";
    } else if (item === "email") {
      return "assets/icons/Conversation.svg";
    } else if (item === "course offer") {
      return "assets/icons/Course.svg";
    } else if (item === "profile evolution") {
      return "assets/icons/user_colorable.svg";
    } else return "assets/icons/notification.svg";
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
      disableRipple: true,
      color: "inherit",
      onClick: handleClick,
      style: {
        width: "30px",
        height: "30px"
      },
      children: type === "conversation" ? /*#__PURE__*/(0,jsx_runtime.jsx)(Badge/* default */.Z, {
        badgeContent: ConversationTotal > 0 ? ConversationTotal.toString() : null,
        color: "warning",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FiMail */.Imn, {
          style: {
            color: "#333333",
            fontSize: "22px",
            strokeWidth: "1"
          }
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Badge/* default */.Z, {
        badgeContent: otherTotal > 0 ? otherTotal.toString() : null,
        color: "warning",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(io_index_esm/* IoIosNotificationsOutline */.ekN, {
          style: {
            color: "#333333",
            fontSize: "25px",
            strokeWidth: "2"
          }
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Menu/* default */.Z, {
      anchorEl: anchorEl,
      open: open,
      onClose: handleClose,
      classes: {
        paper: (notification_module_default()).mui_paper,
        list: (notification_module_default()).mui_list
      },
      transformOrigin: {
        horizontal: "right",
        vertical: "top"
      },
      anchorOrigin: {
        horizontal: "right",
        vertical: "bottom"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (notification_module_default()).notification_head,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (notification_module_default()).notification_head_left,
            children: type === "conversation" ? "Conversations" : "Notifications"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (notification_module_default()).notification_head_right,
            children: [list && list.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              className: (notification_module_default()).actions_btn,
              onClick: readAllNotification,
              children: "Mark all as read"
            }), type === "conversation" ? null : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (notification_module_default()).dot
            }), type === "conversation" ? null : /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              className: (notification_module_default()).actions_btn,
              onClick: function onClick() {
                router.push("/app/student/settings");
                handleClose();
              },
              children: "Settings"
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          id: "scrollableDiv",
          className: (notification_module_default()).notification_list_wrapper,
          children: list && list.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(index_es/* default */.Z, {
            dataLength: list === null || list === void 0 ? void 0 : list.length,
            hasMore: hasMore,
            next: getMore,
            loader: /*#__PURE__*/(0,jsx_runtime.jsx)("small", {
              children: " Loading..."
            }),
            scrollableTarget: "scrollableDiv",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
              className: (notification_module_default()).notification_lists,
              children: list && list.length > 0 ? list === null || list === void 0 ? void 0 : (_list$sort = list.sort(function (a, b) {
                return b === null || b === void 0 ? void 0 : b.createdAt.localeCompare(a === null || a === void 0 ? void 0 : a.createdAt);
              })) === null || _list$sort === void 0 ? void 0 : _list$sort.map(function (item, i) {
                var _item$userData;

                var url = getNotificationImage(item === null || item === void 0 ? void 0 : item.type);
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                  className: (item === null || item === void 0 ? void 0 : item.isViewed) === 1 ? (notification_module_default()).notification_list : (notification_module_default()).notification_list_active,
                  onClick: function onClick() {
                    readSingle(item === null || item === void 0 ? void 0 : item.id, item);
                  },
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (notification_module_default()).list_icon,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                      src: (0,helpers/* getAssets */.Vh)(url !== null && url !== void 0 ? url : "assets/icons/notification.svg")
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (notification_module_default()).list_content,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                      className: (notification_module_default()).list_title,
                      children: item === null || item === void 0 ? void 0 : item.title
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: (notification_module_default()).list_text,
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: item === null || item === void 0 ? void 0 : item.content
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                        className: (notification_module_default()).heighlight,
                        children: [" ", item === null || item === void 0 ? void 0 : (_item$userData = item.userData) === null || _item$userData === void 0 ? void 0 : _item$userData.fullName]
                      })]
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (notification_module_default()).list_time,
                    children: (0,helpers/* whatTimeAgo */.hP)(item === null || item === void 0 ? void 0 : item.createdAt)
                  })]
                }, i);
              }) : "No Notification"
            }), " "]
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              textAlign: "center"
            },
            children: "No Notification Found !"
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
      },
      open: notification,
      autoHideDuration: 3000,
      onClose: handleCloseNotification,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Alert, {
        onClose: handleCloseNotification,
        severity: "info",
        sx: {
          width: "100%"
        },
        children: notificationMsg
      })
    })]
  });
};
/* harmony default export */ var notification = ((/* unused pure expression or super */ null && (StudentNotificationComponent)));
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var bi_index_esm = __webpack_require__(47516);
// EXTERNAL MODULE: ./node_modules/react-icons/cg/index.esm.js
var cg_index_esm = __webpack_require__(80471);
// EXTERNAL MODULE: ./node_modules/react-pro-sidebar/dist/index.es.js
var dist_index_es = __webpack_require__(40979);
// EXTERNAL MODULE: ./node_modules/react-pro-sidebar/dist/css/styles.css
var css_styles = __webpack_require__(41360);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./_unisearch/theme/layout/headers/components/compare/index.jsx
var compare = __webpack_require__(14711);
// EXTERNAL MODULE: ./_unisearch/theme/layout/headers/components/favorite/index.jsx
var favorite = __webpack_require__(86888);
// EXTERNAL MODULE: ./_unisearch/theme/layout/headers/topmenu/topmenu.module.scss
var topmenu_module = __webpack_require__(49004);
var topmenu_module_default = /*#__PURE__*/__webpack_require__.n(topmenu_module);
;// CONCATENATED MODULE: ./_unisearch/theme/layout/headers/topmenu/index.jsx





















var DashboardTopmenu = function DashboardTopmenu() {
  var router = (0,next_router.useRouter)();
  var asPath = router.asPath,
      query = router.query;
  var profileInfo = auth/* authService.getProfileData */.ON.getProfileData();

  var _useState = (0,react.useState)(false),
      userData = _useState[0],
      setUserData = _useState[1];

  var _useState2 = (0,react.useState)(false),
      openMobileMenu = _useState2[0],
      setOpenMobileMenu = _useState2[1];

  var toggleMobileMenu = function toggleMobileMenu() {
    setOpenMobileMenu(function (prev) {
      return !prev;
    });
  };

  var isDesktop = (0,react_responsive.useMediaQuery)({
    query: "(min-width: 991px)"
  });
  (0,react.useEffect)(function () {
    if (!profileInfo) {
      auth/* authService.logout */.ON.logout();
    } else {
      setUserData(profileInfo);
    }
  }, []);

  var generatePath = function generatePath() {
    var pathArray = asPath.split("/");
    pathArray.shift();
    return pathArray[2];
  };

  var RenderNavCard = function RenderNavCard(pathName) {
    switch (pathName) {
      case "elearning":
        return ElearningNav();

      default:
        return StudentNav();
    }
  };

  var StudentNav = function StudentNav() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_es/* ProSidebar */.M7, {
      className: "MobileSideMenu",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_es/* Menu */.v2, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_es/* MenuItem */.sN, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            legacyBehavior: true,
            href: "/app/student",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "".concat(asPath === "/app/student" ? "".concat((topmenu_module_default()).active) : ""),
              children: "Dashboard"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_es/* MenuItem */.sN, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            legacyBehavior: true,
            href: "/app/student/profile",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "".concat(asPath.includes("/app/student/profile") ? "".concat((topmenu_module_default()).active) : ""),
              children: "Profile"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_es/* MenuItem */.sN, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            legacyBehavior: true,
            href: "/app/student/conversation/inbox",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "".concat(asPath.includes("/app/student/conversation") ? "".concat((topmenu_module_default()).active) : ""),
              children: "Conversations"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_es/* MenuItem */.sN, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            legacyBehavior: true,
            href: "/app/student/messages",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "".concat(asPath.includes("/app/student/messages") ? "".concat((topmenu_module_default()).active) : ""),
              children: "Chat"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_es/* MenuItem */.sN, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            legacyBehavior: true,
            href: "/app/student/offered-courses",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "".concat(asPath.includes("/app/student/offered-courses") ? "".concat((topmenu_module_default()).active) : ""),
              children: "Recommended Courses"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_es/* MenuItem */.sN, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            legacyBehavior: true,
            href: "/app/student/report",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "".concat(asPath.includes("/app/student/report") ? "".concat((topmenu_module_default()).active) : ""),
              children: "Report"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_es/* MenuItem */.sN, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            legacyBehavior: true,
            href: "/app/student/application",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "".concat(asPath.includes("/app/student/application") ? "".concat((topmenu_module_default()).active) : ""),
              children: "Application"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_es/* MenuItem */.sN, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            legacyBehavior: true,
            href: "/app/student/counsellor",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "".concat(asPath.includes("/app/student/counsellor") ? "".concat((topmenu_module_default()).active) : ""),
              children: "Counsellors"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_es/* MenuItem */.sN, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            legacyBehavior: true,
            href: "/app/student/favorite",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "".concat(asPath.includes("/app/student/favorite") ? "".concat((topmenu_module_default()).active) : ""),
              children: "Favorite\u2019s"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_es/* MenuItem */.sN, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            legacyBehavior: true,
            href: "/app/student/reading-list",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "".concat(asPath.includes("/app/student/reading-list") ? "".concat((topmenu_module_default()).active) : ""),
              children: "Reading List"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_es/* MenuItem */.sN, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            legacyBehavior: true,
            href: "/app/student/reviews",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "".concat(asPath.includes("/app/student/reviews") ? "".concat((topmenu_module_default()).active) : ""),
              children: "Reviews"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_es/* MenuItem */.sN, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            legacyBehavior: true,
            href: "/app/student/comments",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "".concat(asPath.includes("/app/student/comments") ? "".concat((topmenu_module_default()).active) : ""),
              children: "Comments"
            })
          })
        })]
      })
    });
  };

  var ElearningNav = function ElearningNav() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_es/* ProSidebar */.M7, {
      className: "MobileSideMenu",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_es/* Menu */.v2, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_es/* MenuItem */.sN, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            legacyBehavior: true,
            href: "/app/student/elearning",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "".concat(asPath === "/app/student/elearning" ? "".concat((topmenu_module_default()).active) : ""),
              children: "Dashboard"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_es/* MenuItem */.sN, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            legacyBehavior: true,
            href: "/app/student/elearning/courses",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "".concat(asPath.includes("/app/student/elearning/courses") ? "".concat((topmenu_module_default()).active) : ""),
              children: "Courses"
            })
          })
        })]
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("nav", {
      className: (topmenu_module_default()).nav,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "".concat((topmenu_module_default()).wrapper),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(cg_index_esm/* CgMenu */.pLM, {
          className: (topmenu_module_default()).menu_icon,
          onClick: toggleMobileMenu
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (topmenu_module_default()).left,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            legacyBehavior: true,
            href: "/app/student",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: (topmenu_module_default()).logo,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: (0,helpers/* getAssets */.Vh)("assets/logo-beta.webp"),
                alt: "UniSearch Logo",
                blurDataURL: (0,helpers/* getAssets */.Vh)("assets/logo-beta.webp"),
                placeholder: "blur",
                width: 186,
                height: 30
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (topmenu_module_default()).right,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(header_search["default"], {
            className: (topmenu_module_default()).search_main,
            placeholder: "Search University, Courses, Exam Or Articles"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              legacyBehavior: true,
              href: "/",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                target: "_blank",
                className: (topmenu_module_default()).message_icon,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(bi_index_esm/* BiLinkExternal */.rpH, {
                  style: {
                    minWidth: "20px"
                  }
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "uni-tooltip",
              children: "Go to main website"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StudentNotificationComponent, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              flexShrink: "0"
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(favorite["default"], {})
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              flexShrink: "0"
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(compare["default"], {})
          }), userData ? /*#__PURE__*/(0,jsx_runtime.jsx)(account_menu["default"], {
            userInfo: userData
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            legacyBehavior: true,
            href: "/signin",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "btn btn-secondary btn-md",
              children: "Signin"
            })
          })]
        })]
      })
    }), !isDesktop && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "".concat((topmenu_module_default()).mobile_menu_wrapper, " ").concat(openMobileMenu ? (topmenu_module_default()).menu_open : ""),
      children: RenderNavCard(generatePath())
    })]
  });
};

/* harmony default export */ var topmenu = (DashboardTopmenu);
// EXTERNAL MODULE: ./_recoil/_actions/index.js + 5 modules
var _actions = __webpack_require__(8612);
// EXTERNAL MODULE: ./node_modules/react-icons/hi/index.esm.js
var hi_index_esm = __webpack_require__(53854);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./_unisearch/theme/layout/student_admin/layout.module.scss
var layout_module = __webpack_require__(92818);
var layout_module_default = /*#__PURE__*/__webpack_require__.n(layout_module);
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var bs_index_esm = __webpack_require__(63750);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./_unisearch/theme/layout/student_admin/sidecontent/sidecontent_student.module.scss
var sidecontent_student_module = __webpack_require__(66411);
var sidecontent_student_module_default = /*#__PURE__*/__webpack_require__.n(sidecontent_student_module);
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__(79352);
;// CONCATENATED MODULE: ./_unisearch/theme/layout/student_admin/sidecontent/sidecontent_student.jsx
/* eslint-disable @next/next/no-img-element */




















var SidecontentStudent = function SidecontentStudent(_ref) {
  var profileInfo = _ref.profileInfo;

  var _useRouter = (0,next_router.useRouter)(),
      asPath = _useRouter.asPath,
      query = _useRouter.query;

  var generatePath = function generatePath() {
    var pathArray = asPath.split("/");
    pathArray.shift();
    return pathArray[2];
  };

  var RenderNavCard = function RenderNavCard(pathName) {
    switch (pathName) {
      case "elearning":
        return ElearningNav();

      default:
        return StudentNav();
    }
  };

  var StudentNav = function StudentNav() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          legacyBehavior: true,
          href: "/app/student",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: "".concat(asPath === "/app/student" ? "".concat((sidecontent_student_module_default()).active) : ""),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdOutlineGridView */.uyC, {
              className: (sidecontent_student_module_default()).dashboard_icon
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Dashboard"
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          legacyBehavior: true,
          href: "/app/student/profile",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: "".concat(asPath.includes("/app/student/profile") ? "".concat((sidecontent_student_module_default()).active) : ""),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(cg_index_esm/* CgProfile */.Mdg, {
              className: (sidecontent_student_module_default()).dashboard_icon
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Profile"
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          legacyBehavior: true,
          href: "/app/student/conversation/inbox",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: "".concat(asPath.includes("/app/student/conversation") ? "".concat((sidecontent_student_module_default()).active) : ""),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdEmail */.ixJ, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Conversations"
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          legacyBehavior: true,
          href: "/app/student/messages",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: "".concat(asPath.includes("/app/student/messages") ? "".concat((sidecontent_student_module_default()).active) : ""),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdOutlineQuestionAnswer */.Iqb, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Chat"
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          legacyBehavior: true,
          href: "/app/student/offered-courses",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: "".concat(asPath.includes("/app/student/offered-courses") ? "".concat((sidecontent_student_module_default()).active) : ""),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ri_index_esm/* RiFileList2Line */.y6H, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Recommended Courses"
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          legacyBehavior: true,
          href: "/app/student/report",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: "".concat(asPath.includes("/app/student/report") ? "".concat((sidecontent_student_module_default()).active) : ""),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FiFileText */.NOg, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Report"
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          legacyBehavior: true,
          href: "/app/student/application",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: "".concat(asPath.includes("/app/student/application") ? "".concat((sidecontent_student_module_default()).active) : ""),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(hi_index_esm/* HiOutlineClipboardList */.GwR, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Application"
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          legacyBehavior: true,
          href: "/app/student/counsellor",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: "".concat(asPath.includes("/app/student/counsellor") ? "".concat((sidecontent_student_module_default()).active) : ""),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(bs_index_esm/* BsPersonSquare */.hpB, {
              style: {
                width: "20px"
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Counsellors"
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          legacyBehavior: true,
          href: "/app/student/favorite",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: "".concat(asPath.includes("/app/student/favorite") ? "".concat((sidecontent_student_module_default()).active) : ""),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdFavoriteBorder */.iqB, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Favourites"
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          legacyBehavior: true,
          href: "/app/student/reading-list",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: "".concat(asPath.includes("/app/student/reading-list") ? "".concat((sidecontent_student_module_default()).active) : ""),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(bi_index_esm/* BiBookReader */.$mu, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Reading List"
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          legacyBehavior: true,
          href: "/app/student/reviews",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: "".concat(asPath.includes("/app/student/reviews") ? "".concat((sidecontent_student_module_default()).active) : ""),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdOutlineReviews */.b12, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Reviews"
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          legacyBehavior: true,
          href: "/app/student/comments",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: "".concat(asPath.includes("/app/student/comments") ? "".concat((sidecontent_student_module_default()).active) : ""),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(fa_index_esm/* FaComments */.OdJ, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Comments"
            })]
          })
        })
      }),  false ? /*#__PURE__*/0 : ""]
    });
  };

  var ElearningNav = function ElearningNav() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          legacyBehavior: true,
          href: "/app/student/elearning",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: "".concat(asPath === "/app/student/elearning" ? "".concat((sidecontent_student_module_default()).active) : ""),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdOutlineGridView */.uyC, {
              className: (sidecontent_student_module_default()).dashboard_icon
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Dashboard"
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          legacyBehavior: true,
          href: "/app/student/elearning/courses",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: "".concat(asPath.includes("/app/student/elearning/courses") ? "".concat((sidecontent_student_module_default()).active) : ""),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdMenuBook */.Egn, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Courses"
            })]
          })
        })
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (sidecontent_student_module_default()).side_wrapper,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (sidecontent_student_module_default()).user_wrapper,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (sidecontent_student_module_default()).avatar,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.profileImageSrc) || (0,helpers/* getAssets */.Vh)("assets/student-avatar-small.png"),
          alt: "".concat(profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.firstName, " ").concat(profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.middleName, " ").concat(profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.lastName)
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
        className: (sidecontent_student_module_default()).name,
        children: ["Hello ", profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.firstName, " ", profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.middleName, " ", profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.lastName]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (sidecontent_student_module_default()).link_wrapper,
      children: RenderNavCard(generatePath())
    })]
  });
};

/* harmony default export */ var sidecontent_student = (SidecontentStudent);
;// CONCATENATED MODULE: ./_unisearch/theme/layout/student_admin/index.jsx

var _excluded = ["children", "title", "pageTitle"];

















var LayoutStudent = function LayoutStudent(_ref) {
  var children = _ref.children,
      title = _ref.title,
      _ref$pageTitle = _ref.pageTitle,
      pageTitle = _ref$pageTitle === void 0 ? false : _ref$pageTitle,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useRouter = (0,next_router.useRouter)(),
      asPath = _useRouter.asPath,
      query = _useRouter.query;

  var _useState = (0,react.useState)(true),
      openSideMenu = _useState[0],
      setOpenSideMenu = _useState[1];

  var toggleSideMenu = function toggleSideMenu() {
    setOpenSideMenu(function (prev) {
      return !prev;
    });
  };

  var _useState2 = (0,react.useState)(true),
      pageLaoder = _useState2[0],
      setPageLoader = _useState2[1];

  var isDesktop = (0,react_responsive.useMediaQuery)({
    query: "(min-width: 991px)"
  }); //requil auth action

  var authActions = (0,_actions/* useAuthActions */.X$)();
  var profileInfo = (0,recoil/* useRecoilValue */.sJ)(_state/* authAtom */.L4);
  (0,react.useEffect)(function () {
    //check profile info
    if (!profileInfo || profileInfo.userTypeSlug != "student") {
      authActions.logout("/signin");
      return false;
    }

    if (profileInfo || profileInfo.userTypeSlug == "student") {
      //remove loader
      setTimeout(function () {
        setPageLoader(false);
      }, 1500);
    }
  }, []);
  var pathArray = asPath.split("/");
  pathArray.shift(); //generate active nav

  var isElearning = function isElearning() {
    if (pathArray.length >= 2 && pathArray[2] == "elearning") {
      return true;
    } else {
      return false;
    }
  };

  var isStudent = function isStudent() {
    if (pathArray.length >= 2 && pathArray[2] != "elearning" || pathArray.length == 1) {
      return true;
    } else {
      return false;
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: title
      })
    }), pageLaoder && /*#__PURE__*/(0,jsx_runtime.jsx)(FullPageLoader, {}), !pageLaoder && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (layout_module_default()).content,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(topmenu, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        onClick: toggleSideMenu,
        className: (layout_module_default()).arrow_icon_wrapper,
        children: !openSideMenu ? /*#__PURE__*/(0,jsx_runtime.jsx)(hi_index_esm/* HiOutlineChevronDoubleRight */.nq, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(hi_index_esm/* HiOutlineChevronDoubleLeft */.Gjm, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat((layout_module_default()).sidemenu, " ").concat(!openSideMenu ? (layout_module_default()).close_side_menu : "", " "),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              legacyBehavior: true,
              href: "/app/student",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: "".concat((layout_module_default()).link, " ").concat(isStudent() ? (layout_module_default()).active : ""),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdOutlineSchool */._xL, {})
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              legacyBehavior: true,
              href: "/app/student/elearning",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: "".concat((layout_module_default()).link, " ").concat(isElearning() ? (layout_module_default()).active : ""),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdOutlineComputer */.Viv, {})
              })
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "".concat((layout_module_default()).page_content, " ").concat(!openSideMenu ? (layout_module_default()).margin_zero : ""),
        children: [isDesktop && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (layout_module_default()).side_content,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(sidecontent_student, {
            profileInfo: profileInfo
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (layout_module_default()).main_content,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (layout_module_default()).main_wrapper,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: asPath !== "/app/student/appointment/meet/".concat(query.id) && pageTitle && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: (layout_module_default()).title,
                children: pageTitle
              })
            }), children]
          })
        })]
      })]
    })]
  });
};
/* harmony default export */ var student_admin = ((/* unused pure expression or super */ null && (LayoutStudent)));
// EXTERNAL MODULE: ./_unisearch/theme/layout/footers/footer_one.jsx
var footer_one = __webpack_require__(71634);
// EXTERNAL MODULE: ./_unisearch/theme/layout/components/fixed_popup/index.jsx
var fixed_popup = __webpack_require__(46865);
;// CONCATENATED MODULE: ./_unisearch/theme/layout/university_page/index.jsx









var LayoutUniversityPage = function LayoutUniversityPage(_ref) {
  var children = _ref.children,
      title = _ref.title,
      metaTitle = _ref.metaTitle,
      metaKeywords = _ref.metaKeywords,
      metaDescription = _ref.metaDescription,
      metaUrl = _ref.metaUrl,
      metaImage = _ref.metaImage;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        charSet: "UTF-8"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        httpEquiv: "X-UA-Compatible",
        content: "IE=edge"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1.0"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "p:domain_verify",
        content: "c7f4dc207b5a2b8446692325a0dfb112"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "facebook-domain-verification",
        content: "025mfzyubxk5w3ws6cj9ra838kz8sz"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("title", {
        children: [title !== null && title !== void 0 ? title : "Welcome to UniSearch the complete platform for students and universities", " ", "| UniSearch"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "title",
        content: metaTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "keywords",
        content: metaKeywords
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: metaDescription
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: metaTitle !== null && metaTitle !== void 0 ? metaTitle : "Welcome to UniSearch the complete platform for students and universities | myunisearch"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: metaDescription !== null && metaDescription !== void 0 ? metaDescription : ""
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:type",
        content: "website"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:site_name",
        content: "myunisearch"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: metaUrl !== null && metaUrl !== void 0 ? metaUrl : "https://myunisearch.com/"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: metaImage !== null && metaImage !== void 0 ? metaImage : (0,helpers/* getAssets */.Vh)("assets/logo-beta.png")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:title",
        content: metaTitle !== null && metaTitle !== void 0 ? metaTitle : "Welcome to UniSearch the complete platform for students and universities | myunisearch"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:description",
        content: metaDescription !== null && metaDescription !== void 0 ? metaDescription : "Apply to Universities Abroad with expert guidance from existing students"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:image",
        content: metaImage !== null && metaImage !== void 0 ? metaImage : (0,helpers/* getAssets */.Vh)("assets/logo-beta.png")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:card",
        content: "summary_large_image"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      defer: true,
      src: "https://www.googletagmanager.com/gtag/js?id=G-CBM37S40N3"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      defer: true,
      dangerouslySetInnerHTML: {
        __html: "\n              window.dataLayer = window.dataLayer || [];\n              function gtag(){dataLayer.push(arguments);}\n              gtag('js', new Date());\n              gtag('config', 'G-CBM37S40N3', { page_path: window.location.pathname });\n            "
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      defer: true,
      dangerouslySetInnerHTML: {
        __html: "\n            !function(f,b,e,v,n,t,s)\n            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n            n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n            n.queue=[];t=b.createElement(e);t.async=!0;\n            t.src=v;s=b.getElementsByTagName(e)[0];\n            s.parentNode.insertBefore(t,s)}(window, document,'script',\n            'https://connect.facebook.net/en_US/fbevents.js');\n            fbq('init', '466355328286746');\n            fbq('track', 'PageView');\n            "
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("noscript", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        height: "0",
        width: "0",
        style: {
          display: "none"
        },
        src: "https://www.facebook.com/tr?id=466355328286746&ev=PageView&noscript=1",
        alt: ""
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderUniversity, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("main", {
      children: children
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(fixed_popup["default"], {}), /*#__PURE__*/(0,jsx_runtime.jsx)(footer_one["default"], {})]
  });
};
/* harmony default export */ var university_page = ((/* unused pure expression or super */ null && (LayoutUniversityPage)));
;// CONCATENATED MODULE: ./_unisearch/theme/layout/index.js





/***/ }),

/***/ 11455:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form_title_wrapper":"form_form_title_wrapper__AS8FP","form_group":"form_form_group__pxGSp","asterisk":"form_asterisk__X47V_","error":"form_error__eZC_K","dynamic_form_checkbox_wrapper":"form_dynamic_form_checkbox_wrapper__pRdgc","dynamic_form_checkbox_group":"form_dynamic_form_checkbox_group__bYPzS","checkbox":"form_checkbox__TBG4V","error_msg":"form_error_msg__AIVrW","register_btn":"form_register_btn__PSuQ1","disabled":"form_disabled__evFxv","checkbox_wrapper":"form_checkbox_wrapper__PSCF5","checkbox_lebel":"form_checkbox_lebel__a6NcT","term_link":"form_term_link__snTwa","checkbox_container_wrapper":"form_checkbox_container_wrapper__dRr9e","checkbox_alert_text":"form_checkbox_alert_text__R9F8H","promise_text":"form_promise_text__kYlig","success_modal_wrapper":"form_success_modal_wrapper__CsvHW","success_title":"form_success_title__1DQwK","success_text":"form_success_text__GERIL","form_wrapper":"form_form_wrapper__gwd_l","form_section":"form_form_section__wgK3_"};

/***/ }),

/***/ 3575:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heading_wrapper":"counselling_features_heading_wrapper__SyYFy","title":"counselling_features_title__cOJ7G","sub_text":"counselling_features_sub_text__gImAX","step_card":"counselling_features_step_card__C_5Hu","step_text":"counselling_features_step_text__0LyJx","step_desc":"counselling_features_step_desc__Bzmpc","step_card_icon":"counselling_features_step_card_icon__mP0mK","card_even":"counselling_features_card_even__VWrai"};

/***/ }),

/***/ 77647:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"description_wrapper":"features_description_wrapper__gDYft","full_col":"features_full_col__WKVMW","usa":"features_usa__kxPI1","description_card_wrapper":"features_description_card_wrapper__A3u4G","description_title":"features_description_title__Eliua","custom_desc_title":"features_custom_desc_title__lkqwl","description_sub_title":"features_description_sub_title__0ypTw","margin_top_60":"features_margin_top_60__MqASO","description_card":"features_description_card__oRyxF","description_card_img_wrapper":"features_description_card_img_wrapper__h8qHX","description_card_segment":"features_description_card_segment__8vPwe","align_top":"features_align_top__Rqu2Y","heading_wrapper":"features_heading_wrapper__2qQyt","section_hero":"features_section_hero__yjUQ8","description_and_form_section_wrapper":"features_description_and_form_section_wrapper___kqYd","time_wrapper":"features_time_wrapper__hhxxo","time_card":"features_time_card__rKu_h"};

/***/ }),

/***/ 75343:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form_wrapper":"form_form_wrapper__5oqEc","form_title_wrapper":"form_form_title_wrapper__SYdpa"};

/***/ }),

/***/ 78503:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section_hero":"hero_section_hero__w_VOp","application_week":"hero_application_week__WJc9B","heading_wrapper":"hero_heading_wrapper__cxo5u","heading":"hero_heading__n9Jn6","sub_text":"hero_sub_text__F3aMq","hero_image_wrapper":"hero_hero_image_wrapper__ob20F","custom_heading":"hero_custom_heading__Zmr6g","sub_heading":"hero_sub_heading__27Hc2","btn_wrapper":"hero_btn_wrapper__jAcf3","time_wrapper":"hero_time_wrapper__2uhkC","time_card":"hero_time_card__32BG8","time_text_bold":"hero_time_text_bold__vLMyl","full_width":"hero_full_width__d5mQW","title":"hero_title__RYCzn"};

/***/ }),

/***/ 89628:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section_heroform":"heroform_section_heroform__90u8W","heroform_bg_image_wrapper":"heroform_heroform_bg_image_wrapper__vFT5M","overlay":"heroform_overlay__QYLYu","heading_wrapper":"heroform_heading_wrapper__ZdopP","title":"heroform_title__rBrlJ","sub_title":"heroform_sub_title__doygG","color_black":"heroform_color_black__qv1MH","form_wrapper":"heroform_form_wrapper__AP6dm","form_title":"heroform_form_title__G1h9M"};

/***/ }),

/***/ 7792:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"highlights_title__YGvdW","test_card":"highlights_test_card__VaYXA","test_card_corner":"highlights_test_card_corner__EgDj8","test_icon":"highlights_test_icon__wL3LY","test_title":"highlights_test_title__Y4IvD","test_desc":"highlights_test_desc__Mzt4Y","test_card_circle_1":"highlights_test_card_circle_1__S4sk_","test_card_circle_2":"highlights_test_card_circle_2__IVvtE","section_onlinetest":"highlights_section_onlinetest__XG6m6"};

/***/ }),

/***/ 40716:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form_wrapper":"course_form_form_wrapper__1HCqt","btn_disabled":"course_form_btn_disabled__HO6Iv","dropdown_item":"course_form_dropdown_item__hDuD2","dropdown_head":"course_form_dropdown_head__QQ7I9","dropdown_body":"course_form_dropdown_body__C9S_n","dropdown_type":"course_form_dropdown_type__QGVAy"};

/***/ }),

/***/ 80375:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"live_search_wrapper__SG0ad","input":"live_search_input__SEz1f","option_wrapper":"live_search_option_wrapper__6NWZ6","option":"live_search_option__PygHa"};

/***/ }),

/***/ 48947:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"popup_wrapper":"lead_popup_wrapper__pprfZ","popup_left":"lead_popup_left__879yM","popup_right":"lead_popup_right__OITAD","heading":"lead_heading__QCvG8","sub_heading":"lead_sub_heading___g2nP","right_heading":"lead_right_heading__z5Edn","list_wrapper":"lead_list_wrapper__WwUmP"};

/***/ }),

/***/ 2385:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__FbOip","skeleton-loading":"skeleton_skeleton-loading__do5xO"};

/***/ }),

/***/ 9463:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading":"loader_loading__jXw_J","spinner":"loader_spinner__vIyMy"};

/***/ }),

/***/ 57388:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fixed_popup_container":"fixed_popup_fixed_popup_container__tiomB"};

/***/ }),

/***/ 8213:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"footer_one___next__R_f1h","section_evaluation":"footer_one_section_evaluation__Gu3aL","evaluation_wrapper":"footer_one_evaluation_wrapper__YNdYa","mark":"footer_one_mark__z1T03","sub_title":"footer_one_sub_title__8FsvI","title":"footer_one_title__ds93E","footer_main":"footer_one_footer_main__JllzE","padding_big":"footer_one_padding_big__rViMh","row":"footer_one_row__jJhKa","fnav_title":"footer_one_fnav_title__dp_5_","fnav_list":"footer_one_fnav_list__hXmwo","mobile":"footer_one_mobile__LkBG8","footer_bottom":"footer_one_footer_bottom__mR_mN","bottom_left":"footer_one_bottom_left__q76es","container":"footer_one_container__tLcTk","bottom_right":"footer_one_bottom_right__nh1kw","root":"footer_one_root__WDvrc","country":"footer_one_country___XugY","dot":"footer_one_dot__j67IA","footer_top":"footer_one_footer_top__bLpT2","fiiter_link":"footer_one_fiiter_link__s3Z8G"};

/***/ }),

/***/ 15063:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"profile_wrapper":"account_menu_profile_wrapper__8sabc","name_wrapper":"account_menu_name_wrapper__bUee9","name":"account_menu_name__L8Vvp","id":"account_menu_id__ftCuo","image_wrapper":"account_menu_image_wrapper__1yBQ6","profile_dropdown_wrapper":"account_menu_profile_dropdown_wrapper__g2lcq","profile_info":"account_menu_profile_info__vG7rT","menu_list":"account_menu_menu_list__HBaU6","link":"account_menu_link__Q9DsI","badge":"account_menu_badge__glzth","divider":"account_menu_divider__dyKTs"};

/***/ }),

/***/ 78245:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"compare_dropdown_parent":"compare_compare_dropdown_parent__Xde3S","compare_dropdown":"compare_compare_dropdown__Giz_c","compare":"compare_compare__UDqBX","compare_num":"compare_compare_num__f78TC","comp_count":"compare_comp_count__JU02s"};

/***/ }),

/***/ 32993:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"compare_dropdown_parent":"favorite_compare_dropdown_parent__FK4ps","compare_dropdown":"favorite_compare_dropdown___ajhz","compare":"favorite_compare__v5Dc8","compare_num":"favorite_compare_num__drPuf","comp_count":"favorite_comp_count__XtkJa"};

/***/ }),

/***/ 29343:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header_campaign":"header_campaign_header_campaign__CjDvp"};

/***/ }),

/***/ 65158:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"header_mobile_top___next__t3Jb4","top_nav":"header_mobile_top_top_nav__yrIiZ","active":"header_mobile_top_active__mbUMg","mainHeader_wrapper":"header_mobile_top_mainHeader_wrapper__SOPSa","mainHeader":"header_mobile_top_mainHeader__zMZyI","company_logo":"header_mobile_top_company_logo__J9wYZ","right_options":"header_mobile_top_right_options__CB8H2","user_action":"header_mobile_top_user_action__Lp_QO","cross_icon":"header_mobile_top_cross_icon__W333t"};

/***/ }),

/***/ 25858:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"header_one___next__03MQ3","sticky":"header_one_sticky__GWWZZ","push":"header_one_push__1gl62","topHeader":"header_one_topHeader__cEUgA","top_row":"header_one_top_row__gilqH","left_cel":"header_one_left_cel__yUHK2","right_cel":"header_one_right_cel__DBSoZ","top_nav":"header_one_top_nav__wEwhc","active":"header_one_active__qpvog","uni_info":"header_one_uni_info__SLGIH","mainHeader":"header_one_mainHeader__yXelX","row":"header_one_row__f8qZR","company_logo":"header_one_company_logo__cOT18","main_nav":"header_one_main_nav__wjbB1","mega":"header_one_mega__XzmlR","mega_menu":"header_one_mega_menu__9pLiY","mega_col_wrapper":"header_one_mega_col_wrapper__G7DS2","mega_box":"header_one_mega_box__G5Zl_","menu_title":"header_one_menu_title__P9SfP","menu_sub_title":"header_one_menu_sub_title__jmTyF","menu_content":"header_one_menu_content__AjXNz","sub_arrow":"header_one_sub_arrow__4w7Sq","lable_nav":"header_one_lable_nav__27xYg","icon_trend":"header_one_icon_trend__CQyCr","right_options":"header_one_right_options__wMCNT","compare":"header_one_compare__gUE_m","compare_num":"header_one_compare_num__Jd8aG","user_action":"header_one_user_action__EIB9e","profile_evaluation":"header_one_profile_evaluation__tZKNC","open_mobile":"header_one_open_mobile__ZTL5Q","btn_signin":"header_one_btn_signin__F1XES","open_desktop":"header_one_open_desktop__ZAH0U","menu_icon":"header_one_menu_icon__fISPt","btn_profile_evaluation":"header_one_btn_profile_evaluation__iqbMx","social_links":"header_one_social_links__XXGAK","top_email_address":"header_one_top_email_address__0RgEc","top_phone_num":"header_one_top_phone_num___Ca8j","compare_dropdown_parent":"header_one_compare_dropdown_parent__aojIT","compare_dropdown":"header_one_compare_dropdown__8_D6h","comp_count":"header_one_comp_count__2pWz3"};

/***/ }),

/***/ 76148:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid":"loader_grid__R_OiF","sk1":"loader_sk1__f7kJm","grid2":"loader_grid2__Gcgs9","grid2_skeletor":"loader_grid2_skeletor__3gukO"};

/***/ }),

/***/ 15100:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header_search_wrapper":"header_search_header_search_wrapper__jfPmR","search_placeholder":"header_search_search_placeholder__RfhEA","search_icon":"header_search_search_icon__J8EBc","search_popup":"header_search_search_popup__c601P","cross_icon":"header_search_cross_icon__XMaAr","content_wrapper":"header_search_content_wrapper__yGO9p","tab_wrapper":"header_search_tab_wrapper__RNHQp","hover_change":"header_search_hover_change__FdsJ8"};

/***/ }),

/***/ 7867:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"header_university_header__uXFzx","logo":"header_university_logo__GvEI2"};

/***/ }),

/***/ 49004:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"topmenu___next__pSQQj","nav":"topmenu_nav__4s_z7","wrapper":"topmenu_wrapper__82bQ_","menu":"topmenu_menu__R4HAX","notification":"topmenu_notification__u54oW","left":"topmenu_left__9QD8x","right":"topmenu_right__ewKE1","search_main":"topmenu_search_main__LE9A1","search_inside_dashboard":"topmenu_search_inside_dashboard__Zcv_R","search_icon":"topmenu_search_icon__5_Wnt","message_icon":"topmenu_message_icon__YY25J","user":"topmenu_user__DD9_w","avater":"topmenu_avater__CeSWP","name":"topmenu_name__dSGK9","menu_icon":"topmenu_menu_icon__fC9Nc","active":"topmenu_active__ldYDW","mobile_menu_wrapper":"topmenu_mobile_menu_wrapper__2HKy_","menu_open":"topmenu_menu_open__10b_o","logo":"topmenu_logo__U_k3A"};

/***/ }),

/***/ 92818:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sidemenu":"layout_sidemenu__Pa74M","link":"layout_link__zmYcJ","active":"layout_active___7IY6","close_side_menu":"layout_close_side_menu__N4mTZ","arrow_icon_wrapper":"layout_arrow_icon_wrapper__CIftU","content":"layout_content__C2H__","page_content":"layout_page_content__tmh_a","margin_zero":"layout_margin_zero__tY9zI","main_content":"layout_main_content__zGsCx","side_content":"layout_side_content__RzR14","main_wrapper":"layout_main_wrapper__F_Vbn","title":"layout_title__9xoFl","disable_link":"layout_disable_link__cDytT"};

/***/ }),

/***/ 17681:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mui_paper":"notification_mui_paper__yh7n0","mui_list":"notification_mui_list__B7sOh","notification_head":"notification_notification_head__pxu2Z","notification_head_left":"notification_notification_head_left__mQXcT","notification_head_right":"notification_notification_head_right__7uEqq","dot":"notification_dot__aAcOk","actions_btn":"notification_actions_btn__mgJT6","notification_list_wrapper":"notification_notification_list_wrapper__1A_B3","notification_lists":"notification_notification_lists__v7e89","notification_list":"notification_notification_list__zmHVK","notification_list_active":"notification_notification_list_active__3hIN7","list_icon":"notification_list_icon__GbeKG","list_title":"notification_list_title__VeqR2","list_desc":"notification_list_desc__SgNwN","list_text":"notification_list_text__wKzv_","heighlight":"notification_heighlight__ZgymK","list_time":"notification_list_time__LRtEw"};

/***/ }),

/***/ 66411:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"side_wrapper":"sidecontent_student_side_wrapper__GasJ9","user_wrapper":"sidecontent_student_user_wrapper__PkzBG","avatar":"sidecontent_student_avatar__IgNci","indicator":"sidecontent_student_indicator__meK9e","name":"sidecontent_student_name__j8FD4","email_address":"sidecontent_student_email_address__D0XzC","link_wrapper":"sidecontent_student_link_wrapper__KsZEt","active":"sidecontent_student_active__KF3o7"};

/***/ })

}]);